import React, { Component } from 'react';
import _ from 'lodash';
import {
    Button,
    Card,
    CardImg,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    UncontrolledTooltip
} from 'reactstrap';
import Select from 'react-select/async';
import DropZone from 'react-dropzone';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Services from './services';
import { ProgressButton } from '../../../commons/ProgressButton';
import Mezo from './Mezo';
import Loader from '../../../commons/loader';
import { ImageCard } from '../../../commons/controls';
import SwitchButton from '../../../commons/SwitchButton';
import RFField from '../../../components/Form/RFField';
import RFForm, { FormContext } from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import Wysiwyg from '../../../components/Wysiwyg/Wysiwyg';
import ToolbarBase from '../../../components/Wysiwyg/toolbar/ToolbarBase';
import { parseEditorImage } from '../../../commons/utils';

const SEAT_RADIUS = 10;
const DEFAULT_SEAT_GAP = 30;
const DEFAULT_ROW_GAP = 30;
const DEFAULT_NEW_ROW_SEAT_COUNT = 20;
const MAX_NEW_ROW_SEAT_COUNT = 50;
const DEFAULT_CANVAS_WIDTH = 900;
const DEFAULT_CANVAS_HEIGHT = 620;
const CANVAS_PADDING_LEFT = 120;
const CANVAS_PADDING_TOP = 35;
const CANVAS_PADDING_RIGHT = 120;
const CANVAS_PADDING_BOTTOM = 120;
const GRID_SIZE = 10;
const GRID_MAJOR_SIZE = 50;
const MIN_CANVAS_ZOOM = 0.25;
const MAX_CANVAS_ZOOM = 5;
const ZOOM_STEP = 1.2;
const MAX_UNDO_STEPS = 50;

class TeremterkepEditorBase extends Component {
    constructor(props) {
        super(props);
        this.svgRef = React.createRef();
        this.svgWrapNode = null;
        this.state = {
            angolNyelv: false,
            // TRUE - magyar, FALSE - angol
            magyarSwitchButton: true,
            mentesButtonLoading: false,
            toggleNested: false,
            mezoJson: {},
            orszagValue: {},
            leiras: '',
            leirasAngol: '',
            telepulesSelect: true,
            telepulesMezoInaktiv: true,
            telepulesMezo: [],
            loading: false,
            formProfil: null,
            formLogo: null,
            formGaleria: [],
            allapotok: [],
            tipusok: [],

            formOrszag: '',
            formKereses: '',
            kozterulet: '',
            kozteruletjelleg: '',
            hazszam: '',
            hrsz: '',
            lepcsohaz: '',
            epulet: '',
            emelet: '',
            ajto: '',
            postafiok: '',
            cimSwitchActive: true,
            id: null,
            cim: '',

            allapotValue: '',
            tipusValue: '',
            funkcioid: null,
            deletedImages: [],

            layout: this.createEmptyLayout(),
            newRowSeatCount: DEFAULT_NEW_ROW_SEAT_COUNT,
            originalLayout: null,
            rawLayoutSnapshot: null,
            sectors: [],
            lapOptions: [],
            strategyOptions: [],
            statOptions: [],
            selected: [],
            drag: null,
            panDrag: null,
            frozenCanvasBox: null,
            zoom: 1,
            viewBoxX: 0,
            viewBoxY: 0,
            undoStack: [],
            redoStack: [],
            lastSavedPayload: null,
            errorMessage: '',
            successMessage: '',

            showGridModal: false,
            gridRows: 5,
            gridSeats: 10
        };
    }

    toggleGridModal = () => {
        this.setState((prevState) => ({
            showGridModal: !prevState.showGridModal
        }));
    }

    componentDidMount() {
        this.getData();
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('keydown', this.handleEditorKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('keydown', this.handleEditorKeyDown);
        if (this.svgWrapNode) {
            this.svgWrapNode.removeEventListener('wheel', this.handleNativeSvgWheel, false);
        }
    }

    checkKotelezoMezok = () => {
        const layout = this.state.layout || {};
        
        if (!layout.cod || String(layout.cod).trim() === '') {
            this.props.globals.addError("Az azonosító mező kitöltése kötelező!");
            return false;
        } 
        if (!layout.nam || String(layout.nam).trim() === '') {
            this.props.globals.addError("A név mező kitöltése kötelező!");
            return false;
        }
        if (!layout.vid) {
            this.props.globals.addError("A helyszín megadása kötelező!");
            return false;
        }
        if (!layout.hid) {
            this.props.globals.addError("A terem neve mező kitöltése kötelező!");
            return false;
        }

        const statName = layout.stat && layout.stat.name !== undefined ? layout.stat.name : layout.stat;

        if (!statName || String(statName).trim() === '') {
            this.props.globals.addError("Az állapot kitöltése kötelező!");
            return false;
        }

        const hasEmptyBlockSector = layout.blocks && layout.blocks.some(block => block.seats && block.seats.length > 0 && !block.sec);
        const hasEmptyAreaSector = layout.areas && layout.areas.some(area => area.cap > 0 && !area.sec);
        
        if (hasEmptyBlockSector || hasEmptyAreaSector) {
            this.props.globals.addError("A szektor megadása kötelező!");
            return false; 
        }

        return true;
    }

    /*getData = () => {
        this.setState({ loading: true, errorMessage: '', successMessage: '' });
        let params = new URL(window.location.href).searchParams;
        let id = params.get('id');

        if (id) {
            Services.getTeremkiosztas(id || undefined, (err, res) => {
                if (err) {
                    this.setState({
                        loading: false,
                        id: id,
                        cim: 'Teremtérkép ' + (id ? 'módosítás' : 'felvitel'),
                        errorMessage: 'A teremkiosztás betöltése nem sikerült.'
                    });
                    return;
                }

                const rawLayout = this.extractLayoutFromResponse(res);
                const layout = this.normalizeLayout(rawLayout);

                this.setState({
                    loading: false,
                    id: id || layout.lid || null,
                    cim: 'Teremtérkép ' + (id ? 'módosítás' : 'felvitel'),
                    layout: layout,
                    originalLayout: _.cloneDeep(layout),
                    sectors: this.normalizeSectors(layout.init && layout.init.sectors),
                    lapOptions: Array.isArray(layout.init && layout.init.lap) ? layout.init.lap : this.defaultLapOptions(),
                    strategyOptions: Array.isArray(layout.init && layout.init.str) ? layout.init.str : [],
                    undoStack: [],
                    redoStack: [],
                });
            });
        } else {
            Services.getTeremkiosztas(id || undefined, (err, res) => {
                if (err) {
                    this.setState({
                        loading: false,
                        id: id,
                        cim: 'Teremtérkép ' + (id ? 'módosítás' : 'felvitel'),
                        errorMessage: 'A teremkiosztás betöltése nem sikerült.'
                    });
                    return;
                }

                const rawLayout = this.extractLayoutFromResponse(res);
                const layout = this.normalizeLayout(rawLayout);

            Services.listTerem((errHalls, resHalls) => {
                let teremList = [];
                if (!errHalls && resHalls) {
                    if (!errHalls && resHalls && resHalls[0] && Array.isArray(resHalls[0].list)) {
                            teremList = resHalls[0].list;
                    }
                }

                Services.listHelyszin((errVenues, resVenues) => {
                    let helyszinList = [];
                    if (!errVenues && resVenues) {
                        if (!errVenues && resVenues && resVenues[0] && Array.isArray(resVenues[0].list)) {
                            helyszinList = resVenues[0].list;
                        }
                    }

                    this.setState({
                        loading: false,
                        id: id || layout.lid || null,
                        cim: 'Teremtérkép ' + (id ? 'módosítás' : 'felvitel'),
                        layout: layout,
                        halls: teremList,
                        venues: helyszinList,
                        originalLayout: _.cloneDeep(layout),
                        sectors: this.normalizeSectors(layout.init && layout.init.sectors),
                        lapOptions: Array.isArray(layout.init && layout.init.lap) ? layout.init.lap : this.defaultLapOptions(),
                        strategyOptions: Array.isArray(layout.init && layout.init.str) ? layout.init.str : [],
                        undoStack: [],
                        redoStack: [],
                    });
                });
            });
        }

    }*/

    getData = () => {
        this.setState({ loading: true, errorMessage: '', successMessage: '' });
        let params = new URL(window.location.href).searchParams;
        let id = params.get('id');

        Services.getTeremkiosztas(id || undefined, (err, res) => {
            if (err) {
                this.setState({
                    loading: false,
                    id: id,
                    cim: 'Teremkiosztás ' + (id ? 'módosítás' : 'felvitel'),
                    errorMessage: 'A teremkiosztás betöltése nem sikerült.'
                });
                return;
            }

            const rawLayout = this.extractLayoutFromResponse(res);
            const rawLayoutSnapshot = _.cloneDeep(rawLayout);
            const layout = this.normalizeLayout(rawLayout);

            this.reverseRotationOnLoad(layout);

            if (layout && layout.blocks) {
                layout.blocks.forEach(block => {
                    if (!block.sec && block.seats && block.seats.length > 0) {
                        block.sec = block.seats[0].sec;
                    }
                });
            }

            Services.listTerem((errHalls, resHalls) => {
                let teremList = [];
                if (!errHalls && resHalls) {
                    if (!errHalls && resHalls && resHalls[0] && Array.isArray(resHalls[0].list)) {
                        teremList = resHalls[0].list;
                    }
                }

                Services.listHelyszin((errVenues, resVenues) => {
                    let helyszinList = [];
                    if (!errVenues && resVenues) {
                        if (!errVenues && resVenues && resVenues[0] && Array.isArray(resVenues[0].list)) {
                            helyszinList = resVenues[0].list;
                        }
                    }

                    layout.stat = { name: layout.stat }

                    this.setState({
                        loading: false,
                        id: id || layout.lid || null,
                        cim: 'Teremkiosztás ' + (id ? 'módosítás' : 'felvitel'),
                        layout: layout,
                        halls: teremList,
                        venues: helyszinList,
                        originalLayout: _.cloneDeep(layout),
                        rawLayoutSnapshot: rawLayoutSnapshot,
                        sectors: this.normalizeSectors(layout.init && layout.init.sectors),
                        lapOptions: Array.isArray(layout.init && layout.init.lap) ? layout.init.lap : this.defaultLapOptions(),
                        strategyOptions: Array.isArray(layout.init && layout.init.str) ? layout.init.str : [],
                        statOptions: Array.isArray(layout.init && layout.init.stat) ? layout.init.stat : [],
                        undoStack: [],
                        redoStack: [],
                    });
                });
            });
        });
    }

    extractLayoutFromResponse = (res) => {
        if (Array.isArray(res)) {
            return res[0] || {};
        }
        if (res && Array.isArray(res.data)) {
            return res.data[0] || {};
        }
        if (res && Array.isArray(res.rows)) {
            return res.rows[0] || {};
        }
        if (res && res.layout) {
            return res.layout;
        }
        return res || {};
    }

    createEmptyLayout = () => ({
        lid: null,
        cod: '',
        nam: '',
        hid: null,
        hna: '',
        vna: '',
        ohs: true,
        str: null,
        areas: [],
        blocks: [],
        texts: [],
        soc: 0,
        init: {
            sectors: [],
            lap: this.defaultLapOptions(),
            str: []
        },
        vid: null
    })

    defaultLapOptions = () => ([
        { caption: 'Nem látható', left: false, name: 'N', right: false },
        { caption: 'Bal oldalon', left: true, name: 'B', right: false },
        { caption: 'Jobb oldalon', left: false, name: 'J', right: true },
        { caption: 'Mindkét oldalon', left: true, name: 'M', right: true }
    ])

    normalizeLayout = (raw) => {
        const base = this.createEmptyLayout();
        const layout = Object.assign(base, _.cloneDeep(raw || {}));

        layout.areas = Array.isArray(layout.areas) ? layout.areas.map((area, index) => this.normalizeArea(area, index)) : [];
        layout.blocks = Array.isArray(layout.blocks) ? layout.blocks.map((block, index) => this.normalizeBlock(block, index)) : [];
        layout.texts = Array.isArray(layout.texts) ? layout.texts.map((text, index) => this.normalizeText(text, index)) : [];
        layout.soc = this.toNumber(layout.soc, 0);
        layout.init = layout.init || {};
        layout.init.sectors = Array.isArray(layout.init.sectors) ? layout.init.sectors : [];
        layout.init.lap = Array.isArray(layout.init.lap) ? layout.init.lap : this.defaultLapOptions();
        layout.init.str = Array.isArray(layout.init.str) ? layout.init.str : [];
        return layout;
    }

    normalizeArea = (area, index) => {
        const a = Object.assign({}, area || {});
        a._cid = a._cid || this.makeClientId('area', a.aid || index);
        a.x = this.roundCoord(this.toNumber(a.x, 120 + (index * 20)));
        a.y = this.roundCoord(this.toNumber(a.y, 80 + (index * 20)));
        a.lab = a.lab || '';
        a.las = this.toNumber(a.las, 12);
        a.cap = this.toNumber(a.cap, 0);
        a.wid = this.toNumber(a.wid, 160);
        a.hei = this.toNumber(a.hei, 50);
        a.rad = this.toNumber(a.rad, 0);
        a.rot = this.toNumber(a.rot, 0);
        if (a.sec === undefined && a.sector !== undefined) a.sec = a.sector;
        return a;
    }

    normalizeBlock = (block, index) => {
        const b = Object.assign({}, block || {});
        b._cid = b._cid || this.makeClientId('block', b.bid || index);
        b.lab = b.lab !== undefined && b.lab !== null ? String(b.lab) : String(index + 1);
        b.lss = b.lss || '. szék';
        b.lsp = b.lsp || '';
        b.bsa = !!b.bsa;
        b.lps = b.lps || 'B';
        b.seats = Array.isArray(b.seats) ? b.seats.map((seat, seatIndex) => this.normalizeSeat(seat, seatIndex, index)) : [];
        const anchor = this.getBlockAnchorFromSeats(b);
        b.blp = Array.isArray(b.blp) ? b.blp.slice(0, 4) : [anchor.x, anchor.y, null, null];
        b.blp[0] = this.roundCoord(this.toNumber(b.blp[0], anchor.x));
        b.blp[1] = this.roundCoord(this.toNumber(b.blp[1], anchor.y));
        if (b.blp.length < 4) {
            while (b.blp.length < 4) b.blp.push(null);
        }
        return b;
    }

    normalizeSeat = (seat, seatIndex, blockIndex) => {
        const s = Object.assign({}, seat || {});
        s._cid = s._cid || this.makeClientId('seat', s.sid || (blockIndex + '_' + seatIndex));
        s.x = this.roundCoord(this.toNumber(s.x, 100 + (seatIndex * DEFAULT_SEAT_GAP)));
        s.y = this.roundCoord(this.toNumber(s.y, 100 + (blockIndex * DEFAULT_ROW_GAP)));
        s.lab = s.lab !== undefined && s.lab !== null ? String(s.lab) : String(seatIndex + 1);
        s.num = this.toNumber(s.num, seatIndex + 1);
        return s;
    }

    normalizeText = (text, index) => {
        const t = Object.assign({}, text || {});
        t._cid = t._cid || this.makeClientId('text', t.tid || t.id || index);
        t.x = this.roundCoord(this.toNumber(t.x, 150 + (index * 20)));
        t.y = this.roundCoord(this.toNumber(t.y, 150 + (index * 20)));
        t.rot = this.toNumber(t.rot !== undefined ? t.rot : t.forgatas, 0);
        t.lab = t.lab || t.felirat || '';
        t.las = this.toNumber(t.las !== undefined ? t.las : t.feliratmeret, 14);
        t.col = t.col || t.szin || '#000000';
        return t;
    }

    normalizeSectors = (sectors) => {
        if (!Array.isArray(sectors)) return [];
        return sectors.map((sector) => {
            const item = Object.assign({}, sector);
            item.col = this.normalizeColor(item.col || '008b02');
            return item;
        });
    }

    makeClientId = (prefix, id) => {
        return prefix + '_' + String(id !== undefined && id !== null ? id : '') + '_' + Math.random().toString(36).substr(2, 8);
    }

    toNumber = (value, defaultValue) => {
        if (value === '' || value === null || value === undefined) return defaultValue;
        const parsed = Number(value);
        return Number.isNaN(parsed) ? defaultValue : parsed;
    }

    normalizeColor = (value) => {
        if (!value) return '#008b02';
        const color = String(value).replace('#', '').trim();
        return '#' + color;
    }

    isReadOnly = () => {
        const layout = this.state.layout || {};
        if (!layout.lid && !this.state.id) return false;
        if (layout.lam === false) return true;
        return !!(layout.used || layout.felhasznalt || layout.hasUsage || layout.readOnly || layout.locked);
    }

    nullToString = (data) => {
        if (!data) return '';
        return data;
    }

    handleInputChange = (e) => {
        const { target } = e;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value
        });
    }

    handleChangeSelect = (v, name) => {
        const value = v === '' ? null : v;
        this.setState({
            [name]: value
        });
    }

    onChange = (value, angol) => {
        let obj = {};
        if (angol)
            obj.leirasAngol = value;
        else
            obj.leiras = value;
        this.setState(obj);
    };

    navToList = () => {
        //this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/torzsadatok/helyszin'));
        this.props.globals.route.navigate({
            pathname: this.props.globals.public_url.concat('/admin/torzsadatok/helyszin'),
            search: '?page=3',
        })
    }

    emptyToNull = (obj) => {
        if (!obj || typeof obj !== 'object') return;
        for (let p in obj) {
            if (typeof obj[p] === 'object' && obj[p] !== null) {
                this.emptyToNull(obj[p]);
            } else if (obj.hasOwnProperty(p)) {
                if (obj[p] === '' || obj[p] === undefined) {
                    obj[p] = null;
                }
            }
        }
    }

    emptyOrNull = (data) => {
        if (!data || data === '') return null;
        return data;
    }

    updateLayoutField = (field, value) => {
        if (this.isReadOnly() && field !== 'allapot' && field !== 'status' && field !== 'statName' && field !== 'stat') return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            if (field === 'strName') {
                const strategy = (prevState.strategyOptions || []).find(item => item.name === value);
                layout.str = strategy ? _.cloneDeep(strategy) : null;
                if (!layout.str || layout.str.name !== 'FOGLALAS_KOZOTT_INAKTIV') {
                    layout.soc = 0;
                } else {
                    if (!layout.soc || layout.soc < 1) {
                        layout.soc = 1;
                    }
                }
            } else if (field === 'statName') {
                const stat = (prevState.statOptions || []).find(item => item.name === value);
                layout.stat = stat ? _.cloneDeep(stat) : null;
            } else if (field === 'soc') {
                layout[field] = Math.max(1, this.toNumber(value, 1));
            } else {
                layout[field] = value;
            }
            return {
                layout: layout,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    handleVenueChange = (selectedVenueId) => {
        if (this.isReadOnly()) return;

        const venueId = this.toNumber(selectedVenueId, null);
        const venue = (this.state.venues || []).find(v => v.id === venueId);

        this.setState(prevState => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            layout.vid = venue ? venue.id : null;
            layout.vna = venue ? venue.nev : '';
            layout.hid = null;
            layout.hna = '';

            return {
                layout: layout,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    handleHallChange = (selectedHallId) => {
        if (this.isReadOnly()) return;

        const hallId = this.toNumber(selectedHallId, null);
        const hall = (this.state.halls || []).find(h => h.id === hallId);

        this.setState(prevState => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            layout.hid = hall ? hall.id : null;
            layout.hna = hall ? hall.nev : '';
            return {
                layout: layout,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    getBlockAnchorFromSeats = (block) => {
        const seats = Array.isArray(block && block.seats) ? block.seats : [];
        if (!seats.length) return { x: 100, y: 100 };
        return {
            x: Math.min.apply(null, seats.map(seat => this.toNumber(seat.x, 0))),
            y: Math.min.apply(null, seats.map(seat => this.toNumber(seat.y, 0)))
        };
    }

    getBlockAnchor = (block) => {
        if (block && Array.isArray(block.blp) && block.blp[0] !== null && block.blp[1] !== null) {
            return { x: this.toNumber(block.blp[0], 100), y: this.toNumber(block.blp[1], 100) };
        }
        return this.getBlockAnchorFromSeats(block);
    }

    getBlockBounds = (block) => {
        const seats = Array.isArray(block && block.seats) ? block.seats : [];
        if (!seats.length) {
            const anchor = this.getBlockAnchor(block);
            return { minX: anchor.x, maxX: anchor.x, minY: anchor.y, maxY: anchor.y, centerY: anchor.y };
        }
        const xs = seats.map(seat => this.toNumber(seat.x, 0));
        const ys = seats.map(seat => this.toNumber(seat.y, 0));
        const minX = Math.min.apply(null, xs);
        const maxX = Math.max.apply(null, xs);
        const minY = Math.min.apply(null, ys);
        const maxY = Math.max.apply(null, ys);
        return { minX: minX, maxX: maxX, minY: minY, maxY: maxY, centerY: (minY + maxY) / 2 };
    }


    getAreaBounds = (area) => {
        const x = this.toNumber(area && area.x, 0);
        const y = this.toNumber(area && area.y, 0);
        const width = Math.max(1, this.toNumber(area && area.wid, 0));
        const height = Math.max(1, this.toNumber(area && area.hei, 0));
        const rotation = (this.toNumber(area && area.rot, 0) * Math.PI) / 180;
        const cos = Math.abs(Math.cos(rotation));
        const sin = Math.abs(Math.sin(rotation));
        const rotatedHalfWidth = ((width * cos) + (height * sin)) / 2;
        const rotatedHalfHeight = ((width * sin) + (height * cos)) / 2;
        return {
            minX: x - rotatedHalfWidth,
            maxX: x + rotatedHalfWidth,
            minY: y - rotatedHalfHeight,
            maxY: y + rotatedHalfHeight,
            centerY: y
        };
    }

    getTextBounds = (text) => {
        const x = this.toNumber(text && text.x, 0);
        const y = this.toNumber(text && text.y, 0);
        const fontSize = this.toNumber(text && text.las, 14);
        const labelLength = String((text && text.lab) || '').length;
        const approxTextWidth = Math.max(90, labelLength * fontSize * 0.7);
        return {
            minX: x - (approxTextWidth / 2),
            maxX: x + (approxTextWidth / 2),
            minY: y - fontSize,
            maxY: y + fontSize,
            centerY: y
        };
    }

    getLayoutContentBounds = (layout) => {
        let hasContent = false;
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        const addBounds = (bounds, extraX, extraY) => {
            if (!bounds) return;
            hasContent = true;
            const xPadding = this.toNumber(extraX, 0);
            const yPadding = this.toNumber(extraY, 0);
            minX = Math.min(minX, bounds.minX - xPadding);
            minY = Math.min(minY, bounds.minY - yPadding);
            maxX = Math.max(maxX, bounds.maxX + xPadding);
            maxY = Math.max(maxY, bounds.maxY + yPadding);
        };

        ((layout && layout.areas) || []).forEach((area) => addBounds(this.getAreaBounds(area), 0, 0));
        ((layout && layout.blocks) || []).forEach((block) => addBounds(this.getBlockBounds(block), SEAT_RADIUS, SEAT_RADIUS));
        ((layout && layout.texts) || []).forEach((text) => addBounds(this.getTextBounds(text), 0, 0));

        if (!hasContent) return null;
        return { minX: minX, minY: minY, maxX: maxX, maxY: maxY };
    }

    getAppendPositionBelowLayout = (layout, elementWidth, elementHeight) => {
        const bounds = this.getLayoutContentBounds(layout);
        const blocks = (layout && layout.blocks) || [];
        const width = Math.max(1, this.toNumber(elementWidth, 1));
        const height = Math.max(1, this.toNumber(elementHeight, 1));
        let leftX = 100;

        if (blocks.length) {
            leftX = this.getBlockBounds(blocks[0]).minX;
        } else if (bounds) {
            leftX = bounds.minX;
        }

        return {
            x: this.roundCoord(leftX + (width / 2)),
            y: this.roundCoord((bounds ? bounds.maxY : 100) + DEFAULT_ROW_GAP + (height / 2))
        };
    }

    getSelectedItems = () => {
        const selected = this.state.selected || [];
        const layout = this.state.layout || {};
        if (selected.length === 0) return [];
        return selected.map(sel => {
            if (sel.type === 'block') return (layout.blocks || [])[sel.blockIndex] || null;
            if (sel.type === 'seat') {
                const block = (layout.blocks || [])[sel.blockIndex];
                return block && block.seats ? block.seats[sel.seatIndex] : null;
            }
            if (sel.type === 'area') return (layout.areas || [])[sel.areaIndex] || null;
            if (sel.type === 'text') return (layout.texts || [])[sel.textIndex] || null;
            return null;
        }).filter(item => item !== null);
    }

    selectItem = (itemToSelect, e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.setState((prevState) => {
            const isMulti = e && (e.ctrlKey || e.metaKey);
            let newSelected = [...(prevState.selected || [])];

            if (!itemToSelect) {
                return { selected: [], successMessage: '' };
            }

            const existingIndex = newSelected.findIndex(s => {
                if (s.type !== itemToSelect.type) return false;
                if (s.type === 'block') return s.blockIndex === itemToSelect.blockIndex;
                if (s.type === 'seat') return s.blockIndex === itemToSelect.blockIndex && s.seatIndex === itemToSelect.seatIndex;
                if (s.type === 'area') return s.areaIndex === itemToSelect.areaIndex;
                if (s.type === 'text') return s.textIndex === itemToSelect.textIndex;
                return false;
            });

            if (isMulti) {
                if (existingIndex > -1) {
                    newSelected.splice(existingIndex, 1);
                } else {
                    newSelected.push(itemToSelect);
                }
            } else {
                newSelected = [itemToSelect];
            }

            return { selected: newSelected, successMessage: '' };
        });
    }

    getSelectedItem = () => {
        const items = this.getSelectedItems();
        return items.length > 0 ? items[0] : null;
    }

    createHistorySnapshot = (state) => {
        const source = state || this.state;
        return {
            layout: _.cloneDeep(source.layout || this.createEmptyLayout()),
            selected: source.selected ? _.cloneDeep(source.selected) : []
        };
    }

    pushUndoStack = (state) => {
        const stack = (state.undoStack || []).concat([this.createHistorySnapshot(state)]);
        return stack.length > MAX_UNDO_STEPS ? stack.slice(stack.length - MAX_UNDO_STEPS) : stack;
    }

    undoLayoutChange = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const undoStack = (prevState.undoStack || []).slice();
            if (!undoStack.length) return null;
            const snapshot = undoStack.pop();
            const redoStack = (prevState.redoStack || []).concat([this.createHistorySnapshot(prevState)]);
            return {
                layout: _.cloneDeep(snapshot.layout),
                selected: snapshot.selected ? _.cloneDeep(snapshot.selected) : [],
                undoStack: undoStack,
                redoStack: redoStack.length > MAX_UNDO_STEPS ? redoStack.slice(redoStack.length - MAX_UNDO_STEPS) : redoStack,
                drag: null,
                panDrag: null,
                frozenCanvasBox: null,
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    redoLayoutChange = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const redoStack = (prevState.redoStack || []).slice();
            if (!redoStack.length) return null;
            const snapshot = redoStack.pop();
            const undoStack = (prevState.undoStack || []).concat([this.createHistorySnapshot(prevState)]);
            return {
                layout: _.cloneDeep(snapshot.layout),
                selected: snapshot.selected ? _.cloneDeep(snapshot.selected) : [],
                undoStack: undoStack.length > MAX_UNDO_STEPS ? undoStack.slice(undoStack.length - MAX_UNDO_STEPS) : undoStack,
                redoStack: redoStack,
                drag: null,
                panDrag: null,
                frozenCanvasBox: null,
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    handleEditorKeyDown = (event) => {
        if (!event) return;

        const activeElement = document.activeElement;
        const isInputFocused = activeElement && (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT'
        );

        if (isInputFocused) {
            return;
        }

        const originalKey = String(event.key || '');
        const lowerKey = originalKey.toLowerCase();

        if (event.ctrlKey || event.metaKey) {
            const isUndo = lowerKey === 'z' && !event.shiftKey;
            const isRedo = lowerKey === 'y' || (lowerKey === 'z' && event.shiftKey);

            if (!isUndo && !isRedo) return;
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();
            if (isUndo) this.undoLayoutChange();
            if (isRedo) this.redoLayoutChange();
        }

        if (originalKey === 'Delete') {
            if (this.state.selected && this.state.selected.length > 0 && !this.isReadOnly()) {
                if (event.stopPropagation) event.stopPropagation();
                this.deleteSelected();
                return;
            }
        }

        const isArrowKey = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(originalKey);

        if (isArrowKey && this.state.selected && this.state.selected.length > 0 && !this.isReadOnly()) {
            if (event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();

            const moveStep = 1;
            let moveX = 0;
            let moveY = 0;

            switch (originalKey) {
                case 'ArrowUp': moveY = -moveStep; break;
                case 'ArrowDown': moveY = moveStep; break;
                case 'ArrowLeft': moveX = -moveStep; break;
                case 'ArrowRight': moveX = moveStep; break;
                default: break;
            }

            this.setState((prevState) => {
                const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
                prevState.selected.forEach(selectedItem => { this.moveSelectionOnLayout(layout, selectedItem, moveX, moveY); });

                return {
                    layout: layout,
                    successMessage: '',
                    errorMessage: ''
                };
            });
        }
    }

    getSvgPoint = (event) => {
        const svg = this.svgRef.current;
        if (!svg) return { x: 0, y: 0 };
        const point = svg.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        const ctm = svg.getScreenCTM();
        if (!ctm) return { x: point.x, y: point.y };
        return point.matrixTransform(ctm.inverse());
    }

    startDrag = (itemToSelect, event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        if (this.isReadOnly()) return;

        const point = event ? this.getSvgPoint(event) : { x: 0, y: 0 };
        const frozenCanvasBox = this.getCanvasBox();
        const isMulti = event && (event.ctrlKey || event.metaKey);
        const isRange = event && event.shiftKey;

        this.setState((prevState) => {
            let newSelected = [...(prevState.selected || [])];
            const layout = prevState.layout || {};

            if (isRange && itemToSelect.type === 'block' && newSelected.length > 0) {
                const lastSelected = newSelected[newSelected.length - 1];

                if (lastSelected.type === 'block') {
                    const startIdx = Math.min(itemToSelect.blockIndex, lastSelected.blockIndex);
                    const endIdx = Math.max(itemToSelect.blockIndex, lastSelected.blockIndex);

                    for (let i = startIdx; i <= endIdx; i++) {
                        const alreadyIn = newSelected.some(s => s.type === 'block' && s.blockIndex === i);
                        if (!alreadyIn) {
                            newSelected.push({ type: 'block', blockIndex: i });
                        }
                    }

                    return {
                        selected: newSelected,
                        drag: { lastX: point.x, lastY: point.y },
                        frozenCanvasBox: frozenCanvasBox,
                        undoStack: this.pushUndoStack(prevState),
                        redoStack: [],
                        successMessage: '',
                        errorMessage: ''
                    };
                }
            }

            const existingIndex = newSelected.findIndex(s => {
                if (s.type !== itemToSelect.type) return false;
                if (s.type === 'block') return s.blockIndex === itemToSelect.blockIndex;
                if (s.type === 'seat') return s.blockIndex === itemToSelect.blockIndex && s.seatIndex === itemToSelect.seatIndex;
                if (s.type === 'area') return s.areaIndex === itemToSelect.areaIndex;
                if (s.type === 'text') return s.textIndex === itemToSelect.textIndex;
                return false;
            });

            if (this.isReadOnly()) {
                if (existingIndex === -1) {
                    newSelected = isMulti ? [...newSelected, itemToSelect] : [itemToSelect];
                } else if (isMulti) {
                    newSelected.splice(existingIndex, 1);
                } else {
                    newSelected = [itemToSelect];
                }
                return { selected: newSelected, successMessage: '' };
            }

            if (existingIndex === -1) {
                if (isMulti) {
                    newSelected.push(itemToSelect);
                } else {
                    newSelected = [itemToSelect];
                }
            } else {
                if (isMulti) {
                    newSelected.splice(existingIndex, 1);
                    return { selected: newSelected, successMessage: '' };
                }
            }

            let potentialDeselect = null;
            if (existingIndex !== -1 && !isMulti) {
                potentialDeselect = itemToSelect;
            }

            return {
                selected: newSelected,
                drag: { lastX: point.x, lastY: point.y, hasMoved: false, potentialDeselect: potentialDeselect },
                frozenCanvasBox: frozenCanvasBox,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    stopDrag = () => {
        if (this.state.drag || this.state.panDrag || this.state.resizeDrag || this.state.frozenCanvasBox) {
            this.setState((prevState) => {
                let updates = { drag: null, panDrag: null, resizeDrag: null, frozenCanvasBox: null };
                if (prevState.drag && !prevState.drag.hasMoved && prevState.drag.potentialDeselect) {
                    const toRemove = prevState.drag.potentialDeselect;
                    const newSelected = (prevState.selected || []).filter(s => {
                        if (s.type !== toRemove.type) return true;
                        if (s.type === 'block') return s.blockIndex !== toRemove.blockIndex;
                        if (s.type === 'seat') return s.blockIndex !== toRemove.blockIndex || s.seatIndex !== toRemove.seatIndex;
                        if (s.type === 'area') return s.areaIndex !== toRemove.areaIndex;
                        if (s.type === 'text') return s.textIndex !== toRemove.textIndex;
                        return true;
                    });
                    updates.selected = newSelected;
                }
                return updates;
            });
        }
    }

    startResize = (type, index, direction, event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (this.isReadOnly()) return;

        const point = this.getSvgPoint(event);

        this.setState((prevState) => {
            const layout = prevState.layout || {};
            const item = type === 'text' ? (layout.texts || [])[index] : (layout.areas || [])[index];
            if (!item) return null;

            return {
                resizeDrag: {
                    type: type,
                    index: index,
                    direction: direction,
                    startX: point.x,
                    startY: point.y,
                    origWidth: this.toNumber(item.wid, 0),
                    origHeight: this.toNumber(item.hei, 0),
                    origX: this.toNumber(item.x, 0),
                    origY: this.toNumber(item.y, 0),
                    origLas: this.toNumber(item.las, 14)
                },
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                drag: null,
                panDrag: null
            };
        });
    }

    handleSvgMouseMove = (event) => {
        if (this.state.panDrag) {
            const svg = this.svgRef.current;
            if (!svg) return;
            const rect = svg.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            this.setState((prevState) => {
                if (!prevState.panDrag) return null;
                const box = this.getActiveCanvasBox();
                const view = this.getVisibleViewBox(box, prevState.zoom, prevState.viewBoxX, prevState.viewBoxY);
                const dx = (event.clientX - prevState.panDrag.lastClientX) * (view.width / rect.width);
                const dy = (event.clientY - prevState.panDrag.lastClientY) * (view.height / rect.height);
                const nextView = this.getVisibleViewBox(box, prevState.zoom, prevState.viewBoxX - dx, prevState.viewBoxY - dy);
                return {
                    viewBoxX: nextView.x,
                    viewBoxY: nextView.y,
                    panDrag: {
                        lastClientX: event.clientX,
                        lastClientY: event.clientY
                    }
                };
            });
            return;
        }

        if (this.state.resizeDrag && !this.isReadOnly()) {
            const point = this.getSvgPoint(event);

            this.setState((prevState) => {
                if (!prevState.resizeDrag) return null;

                const dx = point.x - prevState.resizeDrag.startX;
                const dy = point.y - prevState.resizeDrag.startY;
                const dir = prevState.resizeDrag.direction;
                const type = prevState.resizeDrag.type;
                const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
                const item = type === 'text' ? layout.texts[prevState.resizeDrag.index] : layout.areas[prevState.resizeDrag.index];

                if (item) {
                    if (type === 'text') {
                        const newFontSize = Math.max(8, prevState.resizeDrag.origLas + Math.round(dx / 2));
                        item.las = newFontSize;
                    }
                    else {
                        let newWidth = prevState.resizeDrag.origWidth;
                        let newHeight = prevState.resizeDrag.origHeight;
                        let actualDx = 0;
                        let actualDy = 0;

                        if (dir === 'right') {
                            newWidth = Math.max(20, prevState.resizeDrag.origWidth + dx);
                            actualDx = newWidth - prevState.resizeDrag.origWidth;
                        } else if (dir === 'left') {
                            newWidth = Math.max(20, prevState.resizeDrag.origWidth - dx);
                            actualDx = prevState.resizeDrag.origWidth - newWidth;
                        } else if (dir === 'bottom') {
                            newHeight = Math.max(20, prevState.resizeDrag.origHeight + dy);
                            actualDy = newHeight - prevState.resizeDrag.origHeight;
                        } else if (dir === 'top') {
                            newHeight = Math.max(20, prevState.resizeDrag.origHeight - dy);
                            actualDy = prevState.resizeDrag.origHeight - newHeight;
                        }

                        item.wid = this.roundCoord(newWidth);
                        item.hei = this.roundCoord(newHeight);

                        if (dir === 'left' || dir === 'right') item.x = this.roundCoord(prevState.resizeDrag.origX + (actualDx / 2));
                        if (dir === 'top' || dir === 'bottom') item.y = this.roundCoord(prevState.resizeDrag.origY + (actualDy / 2));


                    }
                }

                return { layout: layout };
            });

            return;
        }

        if (!this.state.drag || !this.state.selected || this.isReadOnly()) return;
        const point = this.getSvgPoint(event);

        this.setState((prevState) => {
            if (!prevState.drag || !prevState.selected) return null;
            const dx = point.x - prevState.drag.lastX;
            const dy = point.y - prevState.drag.lastY;
            const moveX = this.getIntegerMoveDelta(dx);
            const moveY = this.getIntegerMoveDelta(dy);
            if (moveX === 0 && moveY === 0) return null;

            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            prevState.selected.forEach(selectedItem => { this.moveSelectionOnLayout(layout, selectedItem, moveX, moveY); });
            return {
                layout: layout,
                drag: {
                    lastX: prevState.drag.lastX + moveX,
                    lastY: prevState.drag.lastY + moveY,
                    hasMoved: true,
                    potentialDeselect: prevState.drag.potentialDeselect
                },
                successMessage: ''
            };
        });
    }

    moveSelectionOnLayout = (layout, selected, dx, dy) => {
        if (!layout || !selected) return;
        if (selected.type === 'seat') {
            const block = layout.blocks[selected.blockIndex];
            const seat = block && block.seats ? block.seats[selected.seatIndex] : null;
            if (!seat) return;
            if (block.pivotX === undefined || block.pivotX === null) {
                let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                block.seats.forEach(s => {
                    const sx = this.toNumber(s.x, 0);
                    const sy = this.toNumber(s.y, 0);
                    if (sx < minX) minX = sx;
                    if (sx > maxX) maxX = sx;
                    if (sy < minY) minY = sy;
                    if (sy > maxY) maxY = sy;
                });
                if (minX !== Infinity) {
                    block.pivotX = (minX + maxX) / 2;
                    block.pivotY = (minY + maxY) / 2;
                }
            }

            const rot = this.toNumber(block.rot, 0);
            if (rot !== 0) {
                const rad = -rot * (Math.PI / 180);
                const localMoveX = dx * Math.cos(rad) - dy * Math.sin(rad);
                const localMoveY = dx * Math.sin(rad) + dy * Math.cos(rad);
                seat.x += localMoveX;
                seat.y += localMoveY;
            } else {
                seat.x += dx;
                seat.y += dy;
            }
        }
        
        if (selected.type === 'block') {
            const block = layout.blocks[selected.blockIndex];
            if (!block) return;
            
            if (block.blp && block.blp.length >= 2) {
                block.blp[0] += dx;
                block.blp[1] += dy;
            }
            if (block.seats) {
                block.seats.forEach(seat => {
                    seat.x += dx;
                    seat.y += dy;
                });
            }
            if (block.pivotX !== undefined && block.pivotX !== null) block.pivotX += dx;
            if (block.pivotY !== undefined && block.pivotY !== null) block.pivotY += dy;
        }
        if (selected.type === 'area') {
            const area = (layout.areas || [])[selected.areaIndex];
            if (area) {
                area.x = this.roundCoord(this.toNumber(area.x, 0) + dx);
                area.y = this.roundCoord(this.toNumber(area.y, 0) + dy);
                
                if (area.pivotX !== undefined && area.pivotX !== null) area.pivotX += dx;
                if (area.pivotY !== undefined && area.pivotY !== null) area.pivotY += dy;
            }
            return;
        }

        if (selected.type === 'text') {
            const text = (layout.texts || [])[selected.textIndex];
            if (text) {
                text.x = this.roundCoord(this.toNumber(text.x, 0) + dx);
                text.y = this.roundCoord(this.toNumber(text.y, 0) + dy);
                
                if (text.pivotX !== undefined && text.pivotX !== null) text.pivotX += dx;
                if (text.pivotY !== undefined && text.pivotY !== null) text.pivotY += dy;
            }
        }
    }

    moveBlockBy = (block, dx, dy) => {
        if (!block) return;
        (block.seats || []).forEach((seat) => {
            seat.x = this.roundCoord(this.toNumber(seat.x, 0) + dx);
            seat.y = this.roundCoord(this.toNumber(seat.y, 0) + dy);
        });
        const anchor = this.getBlockAnchor(block);
        block.blp = Array.isArray(block.blp) ? block.blp : [anchor.x, anchor.y, null, null];
        block.blp[0] = this.roundCoord(this.toNumber(block.blp[0], anchor.x) + dx);
        block.blp[1] = this.roundCoord(this.toNumber(block.blp[1], anchor.y) + dy);
        while (block.blp.length < 4) block.blp.push(null);
    }

    moveBlockTo = (block, x, y) => {
        const anchor = this.getBlockAnchor(block);
        this.moveBlockBy(block, x - anchor.x, y - anchor.y);
    }

    roundCoord = (value) => {
        return Math.round(this.toNumber(value, 0));
    }

    getIntegerMoveDelta = (value) => {
        if (value >= 0) return Math.floor(value);
        return Math.ceil(value);
    }

    isCoordinateField = (field) => {
        return field === 'x' || field === 'y';
    }

    normalizeCoordinateValue = (field, value) => {
        return this.isCoordinateField(field) ? this.roundCoord(value) : value;
    }

    clampNumber = (value, min, max) => {
        return Math.min(max, Math.max(min, value));
    }

    getZoomValue = (value) => {
        return this.clampNumber(this.toNumber(value, 1), MIN_CANVAS_ZOOM, MAX_CANVAS_ZOOM);
    }

    getVisibleViewBox = (box, zoomValue, viewBoxX, viewBoxY) => {
        const zoom = this.getZoomValue(zoomValue);
        const width = Math.max(1, this.toNumber(box && box.width, DEFAULT_CANVAS_WIDTH));
        const height = Math.max(1, this.toNumber(box && box.height, DEFAULT_CANVAS_HEIGHT));
        const visibleWidth = width / zoom;
        const visibleHeight = height / zoom;
        const maxX = Math.max(0, width - visibleWidth);
        const maxY = Math.max(0, height - visibleHeight);
        return {
            x: this.clampNumber(this.toNumber(viewBoxX, 0), 0, maxX),
            y: this.clampNumber(this.toNumber(viewBoxY, 0), 0, maxY),
            width: visibleWidth,
            height: visibleHeight,
            zoom: zoom
        };
    }

    zoomCanvas = (factor, anchorPoint) => {
        const box = this.getActiveCanvasBox();
        this.setState((prevState) => {
            const oldZoom = this.getZoomValue(prevState.zoom);
            const newZoom = this.getZoomValue(oldZoom * factor);
            const oldView = this.getVisibleViewBox(box, oldZoom, prevState.viewBoxX, prevState.viewBoxY);
            const anchor = anchorPoint || {
                x: oldView.x + oldView.width / 2,
                y: oldView.y + oldView.height / 2
            };
            const relativeX = oldView.width ? (anchor.x - oldView.x) / oldView.width : 0.5;
            const relativeY = oldView.height ? (anchor.y - oldView.y) / oldView.height : 0.5;
            const nextWidth = box.width / newZoom;
            const nextHeight = box.height / newZoom;
            const nextX = anchor.x - relativeX * nextWidth;
            const nextY = anchor.y - relativeY * nextHeight;
            const nextView = this.getVisibleViewBox(box, newZoom, nextX, nextY);
            return {
                zoom: newZoom,
                viewBoxX: nextView.x,
                viewBoxY: nextView.y
            };
        });
    }

    resetCanvasView = () => {
        this.setState({
            zoom: 1,
            viewBoxX: 0,
            viewBoxY: 0,
            panDrag: null,
            frozenCanvasBox: null
        });
    }

    setSvgWrapRef = (node) => {
        if (this.svgWrapNode) {
            this.svgWrapNode.removeEventListener('wheel', this.handleNativeSvgWheel, false);
        }
        this.svgWrapNode = node;
        if (this.svgWrapNode) {
            this.svgWrapNode.addEventListener('wheel', this.handleNativeSvgWheel, { passive: false });
        }
    }

    handleNativeSvgWheel = (event) => {
        this.handleSvgWheel(event);
    }

    handleSvgWheel = (event) => {
        if (event) {
            if (event.cancelable !== false && event.preventDefault) event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();
            if (event.nativeEvent) {
                if (event.nativeEvent.cancelable !== false && event.nativeEvent.preventDefault) event.nativeEvent.preventDefault();
                if (event.nativeEvent.stopPropagation) event.nativeEvent.stopPropagation();
                if (event.nativeEvent.stopImmediatePropagation) event.nativeEvent.stopImmediatePropagation();
            }
        }
        const anchor = this.getSvgPoint(event);
        const factor = event.deltaY < 0 ? ZOOM_STEP : 1 / ZOOM_STEP;
        this.zoomCanvas(factor, anchor);
    }

    handleSvgMouseDown = (event) => {
        const target = event && event.target;
        const isBackground = target === this.svgRef.current || (target && target.getAttribute && target.getAttribute('data-svg-background') === 'true');
        if (!isBackground) return;
        if (event.button === 1 || event.shiftKey || event.altKey) {
            if (event.preventDefault) event.preventDefault();
            this.setState({
                selected: [],
                panDrag: {
                    lastClientX: event.clientX,
                    lastClientY: event.clientY
                }
            });
            return;
        }
        this.setState({ selected: [] });
    }

    scrollDragStart = { x: 0, y: 0, initialViewBoxX: 0, initialViewBoxY: 0, type: null };

    handleScrollbarMouseDown = (e, type) => {
        e.preventDefault();
        e.stopPropagation();

        this.scrollDragStart = {
            x: e.clientX,
            y: e.clientY,
            initialViewBoxX: this.state.viewBoxX || 0,
            initialViewBoxY: this.state.viewBoxY || 0,
            type: type
        };

        document.addEventListener('mousemove', this.handleScrollbarMouseMove);
        document.addEventListener('mouseup', this.handleScrollbarMouseUp);
    };

    handleScrollbarMouseMove = (e) => {
        if (!this.scrollDragStart.type) return;
        const sensitivity = 4;

        if (this.scrollDragStart.type === 'horizontal') {
            const deltaX = e.clientX - this.scrollDragStart.x;
            this.setState({
                viewBoxX: this.scrollDragStart.initialViewBoxX + (deltaX * sensitivity)
            });
        } else {
            const deltaY = e.clientY - this.scrollDragStart.y;
            this.setState({
                viewBoxY: this.scrollDragStart.initialViewBoxY + (deltaY * sensitivity)
            });
        }
    };

    handleScrollbarMouseUp = () => {
        this.scrollDragStart.type = null;
        document.removeEventListener('mousemove', this.handleScrollbarMouseMove);
        document.removeEventListener('mouseup', this.handleScrollbarMouseUp);
    };

    updateSelectedField = (field, rawValue, type) => {
        if (this.isReadOnly()) return;
        const selected = this.state.selected || [];
        if (selected.length === 0) return;
        const numericValue = type === 'number' ? this.toNumber(rawValue, 0) : rawValue;
        const value = type === 'number' ? this.normalizeCoordinateValue(field, numericValue) : rawValue;

        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            if (field === 'rowGap') {
                const newGap = this.toNumber(value, 30);
                const selectedBlocks = [];

                selected.forEach(sel => {
                    if (sel.type === 'block') {
                        const b = layout.blocks[sel.blockIndex];
                        if (b) selectedBlocks.push(b);
                    }
                });

                selectedBlocks.sort((a, b) => this.getBlockAnchor(a).y - this.getBlockAnchor(b).y);

                if (selectedBlocks.length > 0) {
                    const startY = this.getBlockAnchor(selectedBlocks[0]).y;

                    selectedBlocks.forEach((b, i) => {
                        b.rowGap = newGap;
                        const targetY = startY + (i * newGap);
                        const bAnchor = this.getBlockAnchor(b);
                        this.moveBlockTo(b, bAnchor.x, targetY);
                    });
                }
            }
            else if (field === 'rot') {
                const newRot = this.toNumber(value, 0);

                let primaryOldRot = 0;
                const firstSel = (prevState.selected || [])[0];
                if (firstSel) {
                    if (firstSel.type === 'block') {
                        const b = layout.blocks[firstSel.blockIndex];
                        if (b) primaryOldRot = this.toNumber(b.rot, 0);
                    } else if (firstSel.type === 'area') {
                        const a = layout.areas[firstSel.areaIndex];
                        if (a) primaryOldRot = this.toNumber(a.rot, 0);
                    } else if (firstSel.type === 'text') {
                        const t = layout.texts[firstSel.textIndex];
                        if (t) primaryOldRot = this.toNumber(t.rot, 0);
                    }
                }

                const deltaRot = newRot - primaryOldRot;

                if (deltaRot !== 0) {
                    const selectedItems = [];
                    let sumCx = 0, sumCy = 0, itemCount = 0;

                    (prevState.selected || []).forEach(sel => {
                        let item = null;
                        let cx = 0, cy = 0;
                        
                        if (sel.type === 'block') {
                            item = layout.blocks[sel.blockIndex];
                            if (item) {
                                let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                                (item.seats || []).forEach(s => {
                                    if (s.x < minX) minX = s.x;
                                    if (s.x > maxX) maxX = s.x;
                                    if (s.y < minY) minY = s.y;
                                    if (s.y > maxY) maxY = s.y;
                                });
                                cx = (minX === Infinity) ? 100 : (minX + maxX) / 2;
                                cy = (minY === Infinity) ? 100 : (minY + maxY) / 2;
                            }
                        } else if (sel.type === 'area') {
                            item = layout.areas[sel.areaIndex];
                            if (item) { cx = this.toNumber(item.x, 0); cy = this.toNumber(item.y, 0); }
                        } else if (sel.type === 'text') {
                            item = layout.texts[sel.textIndex];
                            if (item) { cx = this.toNumber(item.x, 0); cy = this.toNumber(item.y, 0); }
                        }

                        if (item) {
                            selectedItems.push({ item, type: sel.type, cx, cy });
                            sumCx += cx;
                            sumCy += cy;
                            itemCount++;
                        }
                    });

                    const isMulti = itemCount > 1;
                    const commonPivotX = isMulti ? sumCx / itemCount : 0;
                    const commonPivotY = isMulti ? sumCy / itemCount : 0;

                    const radians = (Math.PI / 180) * deltaRot;
                    const cos = Math.cos(radians);
                    const sin = Math.sin(radians);

                    selectedItems.forEach(obj => {
                        const { item, type, cx, cy } = obj;
                        
                        const oldRot = this.toNumber(item.rot, 0);
                        item.rot = oldRot + deltaRot;

                        if (isMulti) {
                            const dx = cx - commonPivotX;
                            const dy = cy - commonPivotY;

                            const newCx = commonPivotX + (dx * cos) - (dy * sin);
                            const newCy = commonPivotY + (dx * sin) + (dy * cos);

                            const shiftX = newCx - cx;
                            const shiftY = newCy - cy;

                            if (type === 'block') {
                                (item.seats || []).forEach(seat => {
                                    seat.x = this.toNumber(seat.x, 0) + shiftX;
                                    seat.y = this.toNumber(seat.y, 0) + shiftY;
                                });
                                if (item.blp && item.blp.length >= 2) {
                                    item.blp[0] = this.toNumber(item.blp[0], 0) + shiftX;
                                    item.blp[1] = this.toNumber(item.blp[1], 0) + shiftY;
                                }
                            } else {
                                item.x = this.toNumber(item.x, 0) + shiftX;
                                item.y = this.toNumber(item.y, 0) + shiftY;
                            }
                        }

                        delete item.pivotX;
                        delete item.pivotY;
                    });
                }
            }
            else {
                (prevState.selected || []).forEach(sel => {
                    if (sel.type === 'seat') {
                        const block = (layout.blocks || [])[sel.blockIndex];
                        const seat = block && block.seats ? block.seats[sel.seatIndex] : null;
                        if (seat) seat[field] = value;
                    }

                    if (sel.type === 'block') {
                        const block = (layout.blocks || [])[sel.blockIndex];
                        if (block) {
                            if (field === 'x' || field === 'y') {
                                const anchor = this.getBlockAnchor(block);
                                this.moveBlockTo(block, field === 'x' ? value : anchor.x, field === 'y' ? value : anchor.y);
                            } else {
                                block[field] = (field === 'sec' && rawValue === '') ? null : value;

                                if (field === 'rev') {
                                    const isReversed = value;
                                    const seatCount = block.seats ? block.seats.length : 0;
                                    if (seatCount > 0) {
                                        block.seats.forEach((seat, index) => {
                                            const number = isReversed ? (seatCount - index) : (index + 1);
                                            seat.lab = String(number);
                                            seat.num = number;
                                        });
                                    }
                                }

                                if (field === 'seatGap') {
                                    const newGap = this.toNumber(value, 30);
                                    const originalBlock = (prevState.layout.blocks || [])[sel.blockIndex];
                                    const oldGap = originalBlock ? this.toNumber(originalBlock.seatGap, 30) : 30;
                                    const anchor = this.getBlockAnchor(block);

                                    if (block.seats && block.seats.length > 0) {
                                        let oldMinX = Infinity, oldMaxX = -Infinity;
                                        block.seats.forEach(seat => {
                                            if (seat.x < oldMinX) oldMinX = seat.x;
                                            if (seat.x > oldMaxX) oldMaxX = seat.x;
                                        });
                                        const oldCenter = (oldMinX + oldMaxX) / 2;

                                        block.seats.forEach(seat => {
                                            const physicalColumn = Math.round((seat.x - anchor.x) / oldGap);
                                            seat.x = anchor.x + (physicalColumn * newGap);
                                        });

                                        let newMinX = Infinity, newMaxX = -Infinity;
                                        block.seats.forEach(seat => {
                                            if (seat.x < newMinX) newMinX = seat.x;
                                            if (seat.x > newMaxX) newMaxX = seat.x;
                                        });
                                        const newCenter = (newMinX + newMaxX) / 2;

                                        const shiftX = oldCenter - newCenter;
                                        block.seats.forEach(seat => {
                                            seat.x += shiftX;
                                        });

                                        if (block.blp && block.blp.length >= 1) {
                                            block.blp[0] += shiftX;
                                        }
                                    }
                                }
                                if (field === 'sec') {
                                    if (block.seats) {
                                        const secValue = (rawValue === '') ? null : value;
                                        block.seats.forEach(seat => {
                                            seat.sec = secValue;
                                        });
                                    }
                                }
                            }
                        }
                    }
                    if (sel.type === 'area') {
                        const area = (layout.areas || [])[sel.areaIndex];
                        if (area) {
                            if (field === 'cap') {
                                area[field] = Math.max(1, this.toNumber(value, 1));
                            } else {
                                area[field] = field === 'sec' && rawValue === '' ? null : value;
                            }
                        }
                    }
                    if (sel.type === 'text') {
                        const text = (layout.texts || [])[sel.textIndex];
                        if (text) text[field] = value;
                    }
                });
            }
            return {
                layout: layout,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    handleNewRowSeatCountChange = (e) => {
        const value = e && e.target ? e.target.value : '';
        this.setState({ newRowSeatCount: value, successMessage: '', errorMessage: '' });
    }

    getNewRowSeatCount = (value) => {
        const parsed = parseInt(value, 10);
        if (Number.isNaN(parsed) || parsed < 1) return null;
        return Math.min(parsed, MAX_NEW_ROW_SEAT_COUNT);
    }

    renumberSeatsInBlock = (block) => {
        if (!block || !block.seats || !block.seats.length) return;

        const seatCount = block.seats.length;
        const isReversed = block.rev;

        block.seats.forEach((seat, index) => {
            const number = isReversed ? (seatCount - index) : (index + 1);
            seat.lab = String(number);
            seat.num = number;
        });

    }

    addGrid = () => {
        if (this.isReadOnly()) return;

        const rowCount = parseInt(this.state.gridRows, 10);
        const seatCount = parseInt(this.state.gridSeats, 10);

        if (isNaN(rowCount) || isNaN(seatCount) || rowCount < 1 || seatCount < 1) return;

        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            if (!layout.blocks) layout.blocks = [];

            const ROW_SPACING = 30;
            const SEAT_SPACING = 30;

            const gridWidth = seatCount > 1 ? (seatCount - 1) * SEAT_SPACING : SEAT_SPACING;
            const gridHeight = rowCount > 1 ? (rowCount - 1) * ROW_SPACING : ROW_SPACING;
            const position = this.getAppendPositionBelowLayout(layout, gridWidth, gridHeight);

            const sharedGridId = this.makeClientId('grid');
            const sectorId = '';

            for (let i = 0; i < rowCount; i++) {
                const currentY = position.y + (i * ROW_SPACING);
                const seats = [];

                for (let j = 0; j < seatCount; j++) {
                    seats.push({
                        sid: this.makeClientId('seat', i + '_' + j),
                        sec: sectorId,
                        x: position.x + (j * SEAT_SPACING),
                        y: currentY,
                        lab: String(j + 1),
                        num: j + 1
                    });
                }

                const newBlock = {
                    bid: null,
                    _cid: this.makeClientId('block', 'new_' + (layout.blocks.length + i)),
                    lab: String(i + 1) + '. sor',
                    lss: '. szék',
                    bsa: false,
                    seats: seats,
                    lps: 'B',
                    sec: sectorId,
                    seatGap: SEAT_SPACING,
                    rowGap: ROW_SPACING,
                    gridId: sharedGridId,
                    gridRowIndex: i,
                    rot: 0
                };

                layout.blocks.push(newBlock);
            }

            const firstNewBlockIndex = layout.blocks.length - rowCount;

            const newSelection = [];
            for (let i = 0; i < rowCount; i++) {
                newSelection.push({ type: 'block', blockIndex: firstNewBlockIndex + i });
            }

            return {
                layout: layout,
                showGridModal: false,
                selected: newSelection,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    addBlock = () => {
        if (this.isReadOnly()) return;
        const requestedSeatCount = this.getNewRowSeatCount(this.state.newRowSeatCount);
        if (!requestedSeatCount) {
            this.setState({ errorMessage: 'Az új sor székszáma 1 és ' + MAX_NEW_ROW_SEAT_COUNT + ' közötti egész szám legyen.' });
            return;
        }

        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const blocks = layout.blocks || [];
            const lastBlock = blocks.length ? blocks[blocks.length - 1] : null;
            const lastBounds = lastBlock ? this.getBlockBounds(lastBlock) : { minY: 70, maxY: 70, minX: 100 };
            const x = lastBlock ? this.getBlockAnchor(lastBlock).x : 100;
            const y = this.roundCoord(lastBounds.maxY + DEFAULT_ROW_GAP);
            const sectorId = this.getDefaultSectorId();
            const seats = [];
            for (let i = 0; i < requestedSeatCount; i++) {
                seats.push({
                    sid: null,
                    _cid: this.makeClientId('seat', 'new_' + i),
                    sec: sectorId,
                    x: this.roundCoord(x + (i * DEFAULT_SEAT_GAP)),
                    y: y,
                    lab: String(i + 1),
                    num: i + 1
                });
            }
            const block = {
                bid: null,
                _cid: this.makeClientId('block', 'new_' + blocks.length),
                lab: String(blocks.length + 1) + '. sor',
                lss: '. szék',
                bsa: false,
                seats: seats,
                blp: [x, y, null, null],
                lps: lastBlock && lastBlock.lps ? lastBlock.lps : 'B',
                rot: 0
            };
            blocks.push(block);
            layout.blocks = blocks;
            return {
                layout: layout,
                selected: [{ type: 'block', blockIndex: blocks.length - 1 }],
                newRowSeatCount: requestedSeatCount,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

    addArea = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const areas = layout.areas || [];
            const width = 180;
            const height = 50;
            const position = this.getAppendPositionBelowLayout(layout, width, height);
            areas.push({
                aid: null,
                _cid: this.makeClientId('area', 'new_' + areas.length),
                sec: '',
                x: position.x,
                y: position.y,
                lab: 'Nem helyre szóló terület',
                las: 12,
                cap: 30,
                wid: width,
                hei: height,
                rad: 5,
                rot: 0
            });
            layout.areas = areas;
            return { layout: layout, selected: [{ type: 'area', areaIndex: areas.length - 1 }], undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
        });
    }

    addObject = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const areas = layout.areas || [];
            const width = 220;
            const height = 35;
            const position = this.getAppendPositionBelowLayout(layout, width, height);
            areas.push({
                aid: null,
                _cid: this.makeClientId('area', 'object_' + areas.length),
                sec: null,
                x: position.x,
                y: position.y,
                lab: 'Színpad',
                las: 12,
                cap: 0,
                wid: width,
                hei: height,
                rad: 5,
                rot: 0
            });
            layout.areas = areas;
            return { layout: layout, selected: [{ type: 'area', areaIndex: areas.length - 1 }], undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
        });
    }

    addText = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const texts = layout.texts || [];
            const width = 220;
            const height = 35;
            const position = this.getAppendPositionBelowLayout(layout, width, height);
            texts.push({
                tid: null,
                _cid: this.makeClientId('text', 'new_' + texts.length),
                x: position.x,
                y: position.y,
                rot: 0,
                lab: 'Felirat',
                las: 14,
                col: '#000000'
            });
            layout.texts = texts;
            return { layout: layout, selected: [{ type: 'text', textIndex: texts.length - 1 }], undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
        });
    }

    getDefaultSectorId = () => {
        const sectors = this.state.sectors || [];
        if (!sectors.length) return 100;
        const active = sectors.find(sector => sector.use !== false);
        return active ? active.id : sectors[0].id;
    }

    deleteSelected = () => {
        if (this.isReadOnly()) return;
        const selected = this.state.selected || [];
        if (selected.length === 0) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const seatsToDelete = {};
            const blocksToDelete = [];
            const areasToDelete = [];
            const textsToDelete = [];

            selected.forEach(sel => {
                if (sel.type === 'seat') {
                    if (!seatsToDelete[sel.blockIndex]) seatsToDelete[sel.blockIndex] = [];
                    seatsToDelete[sel.blockIndex].push(sel.seatIndex);
                }
                if (sel.type === 'block') blocksToDelete.push(sel.blockIndex);
                if (sel.type === 'area') areasToDelete.push(sel.areaIndex);
                if (sel.type === 'text') textsToDelete.push(sel.textIndex);
            });

            Object.keys(seatsToDelete).forEach(blockIdxStr => {
                const bIdx = parseInt(blockIdxStr, 10);
                const block = (layout.blocks || [])[bIdx];
                if (block && block.seats) {
                    const sIndices = seatsToDelete[bIdx].sort((a, b) => b - a);
                    sIndices.forEach(sIdx => {
                        block.seats.splice(sIdx, 1);
                    });
                    this.renumberSeatsInBlock(block);
                }
            });

            if (layout.texts) { textsToDelete.sort((a, b) => b - a).forEach(idx => layout.texts.splice(idx, 1)); }
            if (layout.areas) { areasToDelete.sort((a, b) => b - a).forEach(idx => layout.areas.splice(idx, 1)); }
            if (layout.blocks) { blocksToDelete.sort((a, b) => b - a).forEach(idx => layout.blocks.splice(idx, 1)); }
            return { layout: layout, selected: [], undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
        });
    }

    duplicateSelected = () => {
        if (this.isReadOnly()) return;
        const selected = this.state.selected || [];
        if (selected.length === 0) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            let nextSelected = [];
            const seatsToDup = {};
            const blocksToDup = [];
            const areasToDup = [];
            const textsToDup = [];

            selected.forEach(sel => {
                if (sel.type === 'seat') {
                    if (!seatsToDup[sel.blockIndex]) seatsToDup[sel.blockIndex] = [];
                    seatsToDup[sel.blockIndex].push(sel.seatIndex);
                }
                if (sel.type === 'block') blocksToDup.push(sel.blockIndex);
                if (sel.type === 'area') areasToDup.push(sel.areaIndex);
                if (sel.type === 'text') textsToDup.push(sel.textIndex);
            });
            Object.keys(seatsToDup).forEach(blockIdxStr => {
                const bIdx = parseInt(blockIdxStr, 10);
                const block = (layout.blocks || [])[bIdx];
                if (block && block.seats) {
                    const sIndices = seatsToDup[bIdx].sort((a, b) => b - a);
                    sIndices.forEach(sIdx => {
                        const seat = block.seats[sIdx];
                        if (seat) {
                            const copy = _.cloneDeep(seat);
                            copy.sid = null;
                            copy._cid = this.makeClientId('seat', 'copy');
                            copy.x = this.toNumber(copy.x, 0) + DEFAULT_SEAT_GAP;
                            copy.num = this.toNumber(copy.num, 0) + 1;
                            copy.lab = String(copy.num);
                            block.seats.splice(sIdx + 1, 0, copy);
                            nextSelected.push({ type: 'seat', blockIndex: bIdx, seatIndex: sIdx + 1 });
                        }
                    });
                    this.renumberSeatsInBlock(block);
                }
            });
            if (layout.blocks) {
                blocksToDup.sort((a, b) => b - a).forEach(idx => {
                    const block = layout.blocks[idx];
                    if (block) {
                        const copy = _.cloneDeep(block);
                        this.clearBlockIds(copy);
                        copy._cid = this.makeClientId('block', 'copy');
                        copy.lab = String((layout.blocks || []).length + 1);
                        this.moveBlockBy(copy, 0, DEFAULT_ROW_GAP);
                        layout.blocks.splice(idx + 1, 0, copy);
                        nextSelected.push({ type: 'block', blockIndex: idx + 1 });
                    }
                });
            }
            if (layout.areas) {
                areasToDup.sort((a, b) => b - a).forEach(idx => {
                    const area = layout.areas[idx];
                    if (area) {
                        const copy = _.cloneDeep(area);
                        copy.aid = null;
                        copy._cid = this.makeClientId('area', 'copy');
                        copy.x = this.toNumber(copy.x, 0) + 20;
                        copy.y = this.toNumber(copy.y, 0) + 20;
                        layout.areas.splice(idx + 1, 0, copy);
                        nextSelected.push({ type: 'area', areaIndex: idx + 1 });
                    }
                });
            }
            if (layout.texts) {
                textsToDup.sort((a, b) => b - a).forEach(idx => {
                    const text = layout.texts[idx];
                    if (text) {
                        const copy = _.cloneDeep(text);
                        copy.tid = null;
                        copy.id = null;
                        copy._cid = this.makeClientId('text', 'copy');
                        copy.x = this.toNumber(copy.x, 0) + 20;
                        copy.y = this.toNumber(copy.y, 0) + 20;
                        layout.texts.splice(idx + 1, 0, copy);
                        nextSelected.push({ type: 'text', textIndex: idx + 1 });
                    }
                });
            }
            return { layout: layout, selected: nextSelected, undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
        });
    }

    duplicateLayout = () => {
        if (this.isReadOnly()) return;
        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            layout.lid = null;
            layout.cod = (layout.cod || 'teremkiosztas') + '_copy';
            layout.nam = (layout.nam || 'Teremkiosztás') + ' másolat';
            (layout.areas || []).forEach((area) => { area.aid = null; area._cid = this.makeClientId('area', 'copy'); });
            (layout.blocks || []).forEach((block) => this.clearBlockIds(block));
            (layout.texts || []).forEach((text) => { text.tid = null; text.id = null; text._cid = this.makeClientId('text', 'copy'); });
            return { layout: layout, id: null, selected: [], undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: 'A teremkiosztás másolatként szerkeszthető.', errorMessage: '' };
        });
    }

    clearBlockIds = (block) => {
        block.bid = null;
        block._cid = this.makeClientId('block', 'copy');
        (block.seats || []).forEach((seat) => {
            seat.sid = null;
            seat._cid = this.makeClientId('seat', 'copy');
        });
    }

    getSectorColor = (sectorId) => {
        const sectors = this.state.sectors || [];
        const sector = sectors.find(item => String(item.id) === String(sectorId));
        return sector ? sector.col : '#008b02';
    }

    getSectorName = (sectorId) => {
        const sectors = this.state.sectors || [];
        const sector = sectors.find(item => String(item.id) === String(sectorId));
        return sector ? (sector.nam || sector.name || sector.cod || sector.id) : '';
    }

    getCanvasBox = () => {
        const layout = this.state.layout || {};
        let hasContent = false;
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        const expand = (left, top, right, bottom) => {
            hasContent = true;
            minX = Math.min(minX, left);
            minY = Math.min(minY, top);
            maxX = Math.max(maxX, right);
            maxY = Math.max(maxY, bottom);
        };

        (layout.areas || []).forEach((area) => {
            const x = this.toNumber(area.x, 0);
            const y = this.toNumber(area.y, 0);
            const width = Math.max(1, this.toNumber(area.wid, 0));
            const height = Math.max(1, this.toNumber(area.hei, 0));
            const rotation = (this.toNumber(area.rot, 0) * Math.PI) / 180;
            const cos = Math.abs(Math.cos(rotation));
            const sin = Math.abs(Math.sin(rotation));
            const rotatedHalfWidth = ((width * cos) + (height * sin)) / 2;
            const rotatedHalfHeight = ((width * sin) + (height * cos)) / 2;
            expand(x - rotatedHalfWidth - 24, y - rotatedHalfHeight - 24, x + rotatedHalfWidth + 24, y + rotatedHalfHeight + 24);
        });

        (layout.blocks || []).forEach((block) => {
            const bounds = this.getBlockBounds(block);
            expand(
                bounds.minX - SEAT_RADIUS - 90,
                bounds.minY - SEAT_RADIUS - 35,
                bounds.maxX + SEAT_RADIUS + 90,
                bounds.maxY + SEAT_RADIUS + 35
            );
        });

        (layout.texts || []).forEach((text) => {
            const x = this.toNumber(text.x, 0);
            const y = this.toNumber(text.y, 0);
            const fontSize = this.toNumber(text.las, 14);
            const labelLength = String(text.lab || '').length;
            const approxTextWidth = Math.max(90, labelLength * fontSize * 0.7);
            expand(x - (approxTextWidth / 2) - 30, y - fontSize - 30, x + (approxTextWidth / 2) + 30, y + fontSize + 30);
        });

        if (!hasContent) {
            return { width: DEFAULT_CANVAS_WIDTH, height: DEFAULT_CANVAS_HEIGHT, offsetX: 0, offsetY: 0 };
        }

        const offsetX = minX < CANVAS_PADDING_LEFT ? CANVAS_PADDING_LEFT - minX : 0;
        const offsetY = minY < CANVAS_PADDING_TOP ? CANVAS_PADDING_TOP - minY : 0;
        const width = Math.max(DEFAULT_CANVAS_WIDTH, Math.ceil(maxX + offsetX + CANVAS_PADDING_RIGHT));
        const height = Math.max(DEFAULT_CANVAS_HEIGHT, Math.ceil(maxY + offsetY + CANVAS_PADDING_BOTTOM));

        return { width: width, height: height, offsetX: offsetX, offsetY: offsetY };
    }

    getActiveCanvasBox = () => {
        return this.state.frozenCanvasBox || this.getCanvasBox();
    }

    buildPayload = () => {
        const layout = _.cloneDeep(this.state.layout || this.createEmptyLayout());

        this.normalizeLayoutCoordinatesForSave(layout);
        delete layout.originalLayout;
        (layout.areas || []).forEach(area => delete area._cid);
        (layout.blocks || []).forEach((block) => {
            delete block._cid;
            (block.seats || []).forEach(seat => delete seat._cid);
        });
        (layout.texts || []).forEach(text => delete text._cid);
        return layout;
    }

    normalizeLayoutCoordinatesForSave = (layout) => {
        (layout.areas || []).forEach((area) => {
            area.x = this.roundCoord(area.x);
            area.y = this.roundCoord(area.y);
        });
        (layout.blocks || []).forEach((block) => {
            if (Array.isArray(block.blp)) {
                block.blp[0] = this.roundCoord(block.blp[0]);
                block.blp[1] = this.roundCoord(block.blp[1]);
            }
            // (block.seats || []).forEach((seat) => {
            //     seat.x = this.roundCoord(seat.x);
            //     seat.y = this.roundCoord(seat.y);
            // });
        });
        (layout.texts || []).forEach((text) => {
            text.x = this.roundCoord(text.x);
            text.y = this.roundCoord(text.y);
        });
    }

removeSeatSids = (obj) => {
    obj.blocks?.forEach(block => {
        block.seats?.forEach(seat => {
            delete seat.sid;
        });
    });

    return obj;
}

removeHashFromTextColors = (obj) => {
    if (Array.isArray(obj.texts)) {
        obj.texts.forEach(text => {
            if (typeof text.col === 'string') {
                text.col = text.col.replaceAll('#', '');
            }
        });
    }

    return obj;
}

applyRotationToPayload = (payload) => {
    if (!payload.blocks) return;

    payload.blocks.forEach(block => {
      if (block.rot && block.rot !== 0 && block.seats && block.seats.length > 0) {
        
        let minX = Math.min(...block.seats.map(s => s.x));
        let maxX = Math.max(...block.seats.map(s => s.x));
        let minY = Math.min(...block.seats.map(s => s.y));
        let maxY = Math.max(...block.seats.map(s => s.y));
        
        let pivotX = block.pivotX !== undefined ? block.pivotX : (minX + maxX) / 2;
        let pivotY = block.pivotY !== undefined ? block.pivotY : (minY + maxY) / 2;

        const radians = (Math.PI / 180) * block.rot;
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);

        block.seats.forEach(seat => {
          const dx = seat.x - pivotX;
          const dy = seat.y - pivotY;
          
          seat.x = Math.round((pivotX + (dx * cos) - (dy * sin)) * 100000) / 100000;
          seat.y = Math.round((pivotY + (dx * sin) + (dy * cos)) * 100000) / 100000;
        });
      }
    });
  }

  reverseRotationOnLoad = (layout) => {
    if (!layout || !layout.blocks) return;

    layout.blocks.forEach(block => {
      if (block.rot && block.rot !== 0 && block.seats && block.seats.length > 0) {
        
        let minX = Math.min(...block.seats.map(s => s.x));
        let maxX = Math.max(...block.seats.map(s => s.x));
        let minY = Math.min(...block.seats.map(s => s.y));
        let maxY = Math.max(...block.seats.map(s => s.y));
        
        let pivotX = (minX + maxX) / 2;
        let pivotY = (minY + maxY) / 2;

        const radians = (Math.PI / 180) * (-block.rot); 
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);

        const localSeats = block.seats.map(seat => {
          const sDx = seat.x - pivotX;
          const sDy = seat.y - pivotY;
          return {
            seatRef: seat,
            localX: pivotX + (sDx * cos) - (sDy * sin),
            localY: pivotY + (sDx * sin) + (sDy * cos)
          };
        });

        localSeats.forEach(ls => {
          const neighborsY = localSeats.filter(other => Math.abs(other.localY - ls.localY) <= 3);
          const avgY = neighborsY.reduce((sum, current) => sum + current.localY, 0) / neighborsY.length;
          
          ls.seatRef.x = Math.round(ls.localX);
          ls.seatRef.y = Math.round(avgY);
        });

        delete block.pivotX;
        delete block.pivotY;
      }
    });
  }

mentes = (e) => {
    if (e && e.preventDefault) e.preventDefault();

    if (!this.checkKotelezoMezok()) {
        return;
    }

    let payload;

    if (this.isReadOnly()) {
        payload = _.cloneDeep(this.state.rawLayoutSnapshot || this.buildPayload());
        this.emptyToNull(payload);
        payload.stat = this.state.layout.stat && this.state.layout.stat.name;
        payload.hid = this.state.layout.hid;
        payload.str = payload.str && payload.str.name;
        if (this.state.id) payload.lid = this.toNumber(this.state.id, payload.lid);
    } else {
        payload = this.buildPayload();
        this.emptyToNull(payload);

        // const hasEmptyBlockSector = payload.blocks && payload.blocks.some(block => block.seats && block.seats.length > 0 && !block.sec);
        // const hasEmptyAreaSector = payload.areas && payload.areas.some(area => area.cap > 0 && !area.sec);
        // if (hasEmptyBlockSector || hasEmptyAreaSector) {
        //     this.setState({ 
        //         errorMessage: 'A szektor megadása kötelező!', 
        //         successMessage: '' 
        //     });
        //     return; 
        // }

        payload.str = payload.str && payload.str.name;
        payload.hid = this.state.layout.hid
        payload.stat = payload.stat && payload.stat.name;
        if (this.state.id) payload.lid = this.state.id
    }

    let payloadWoSid = payload;
    if (!this.isReadOnly()) {
        payloadWoSid = this.removeSeatSids(payload);
    }
    payloadWoSid = this.removeHashFromTextColors(payloadWoSid);
    if (!this.isReadOnly()) {
        this.applyRotationToPayload(payloadWoSid);
    }

    this.setState({ mentesButtonLoading: true, errorMessage: '', successMessage: '', lastSavedPayload: payload });

    const done = (err) => {
        this.setState({ mentesButtonLoading: false });
        if (err) {
            this.setState({ errorMessage: 'A teremkiosztás mentése nem sikerült.' });
            return;
        }
        this.setState({ successMessage: 'A teremkiosztás mentése sikeres.' });
        this.navToList()
    };

    const methodName = this.findSaveServiceName();
    if (!methodName) {
        console.log('Teremkiosztás mentési payload:', payloadWoSid);
        this.setState({
            mentesButtonLoading: false,
            successMessage: 'A mentés service nincs bekötve.'
        });
        return;
    }

    try {
        const id = payloadWoSid.lid || this.state.id;
        const method = Services[methodName];
        let result;
        if (methodName.indexOf('update') === 0 || methodName.indexOf('modosit') === 0) {
            result = method(id, payloadWoSid, done);
        } else if (id && method.length >= 3) {
            result = method(id, payloadWoSid, done);
        } else {
            result = method(id, payloadWoSid, done);
        }
        if (result && typeof result.then === 'function') {
            result.then(() => done()).catch(done);
        }
    } catch (ex) {
        done(ex);
    }
}

findSaveServiceName = () => {
    const candidates = [
        'saveTeremkiosztasLayout',
        'updateTeremkiosztasLayout',
        'saveTeremkiosztas',
        'updateTeremkiosztas',
        'createTeremkiosztas',
        'postTeremkiosztas',
        'modositTeremkiosztas'
    ];
    return candidates.find(name => Services && typeof Services[name] === 'function');
}

renderInput = (label, value, onChange, type, disabled) => {
    return (
        <div style={styles.field}>
            <label style={styles.label}>{label}</label>
            <input
                type={type || 'text'}
                value={value === undefined || value === null ? '' : value}
                onChange={onChange}
                disabled={disabled}
                style={styles.input}
            />
        </div>
    );
}

renderSelect = (label, value, onChange, options, disabled) => {
    return (
        <div style={styles.field}>
            <label style={styles.label}>{label}</label>
            <select value={value === undefined || value === null ? '' : value} onChange={onChange} disabled={disabled} style={styles.input}>
                <option value="">--</option>
                {(options || []).map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
}

renderBaseData = () => {
    const selected = this.state.selected || [];
    if (selected.length > 0) return null;

    const layout = this.state.layout || this.createEmptyLayout();
    const allapotok = [
        {
            "bagde": "success",
            "label": "Aktív",
            "value": "AKTIV"
        },
        {
            "bagde": "default",
            "label": "Inaktív",
            "value": "INAKTIV"
        }
    ]; // TODO initbe felvenni

    const readOnly = this.isReadOnly();
    const isEditMode = false//!!layout.lid || !!this.state.id; //ezt majd vissza kell írni false-ról 
    const strategyOptions = (this.state.strategyOptions || []).map(item => ({ value: item.name, label: item.caption || item.name }));
    const statOptions = (this.state.statOptions || []).map(item => ({ value: item.name, label: item.caption || item.name }));
    const allVenues = this.state.venues || [];
    const venueOptions = allVenues.map(v => ({ value: v.id, label: v.nev }));
    if (venueOptions.length === 0 && layout.vid && layout.vna) {
        venueOptions.push({ value: layout.vid, label: layout.vna });
    }
    const allHalls = this.state.halls || [];
    const filteredHalls = allHalls.filter(hall => hall.helyszin === layout.vna);
    const hallOptions = filteredHalls.map(h => ({ value: h.id, label: h.nev }));
    if (hallOptions.length === 0 && layout.hid && layout.hna) {
        hallOptions.push({ value: layout.hid, label: layout.hna });
    }
    return (
        <div style={styles.panel}>
            <h5 style={styles.panelTitle}>Alapadatok</h5>
            {this.renderInput('Azonosító*', layout.cod, e => this.updateLayoutField('cod', e.target.value), 'text', readOnly || !!layout.lid)}
            {this.renderInput('Név*', layout.nam, e => this.updateLayoutField('nam', e.target.value), 'text', readOnly)}
            {/*this.renderInput('Terem ID', layout.hid, e => this.updateLayoutField('hid', this.toNumber(e.target.value, null)), 'number', readOnly)}*/}
            {/* {this.renderInput('Terem neve', layout.hna, e => this.updateLayoutField('hna', e.target.value), 'text', readOnly)} */}
            {/* {this.renderInput('Helyszín', layout.vna, e => this.updateLayoutField('vna', e.target.value), 'text', readOnly)} */}
            {this.renderSelect('Helyszín*', layout.vid, e => this.handleVenueChange(e.target.value), venueOptions, readOnly || isEditMode)}
            {this.renderSelect('Terem neve*', layout.hid, e => this.handleHallChange(e.target.value), hallOptions, readOnly || isEditMode)}
            {this.renderSelect('Stratégia', layout.str && layout.str.name, e => this.updateLayoutField('strName', e.target.value), strategyOptions, readOnly)}
            {layout.str && layout.str.name === 'FOGLALAS_KOZOTT_INAKTIV' ? (
                this.renderInput('Székkihagyás*', layout.soc, e => this.updateLayoutField('soc', e.target.value), 'number', readOnly)
            ) : null}
            {this.renderSelect('Állapot*', layout.stat && layout.stat.name, e => this.updateLayoutField('statName', e.target.value), statOptions, false)}
            {readOnly ? <div style={styles.warning}>A teremkiosztás felhasznált/zárolt, a teremkép nem szerkeszthető.</div> : null}
        </div>
    );
}

renderToolbar = () => {
    const readOnly = this.isReadOnly();
    const requestedSeatCount = this.getNewRowSeatCount(this.state.newRowSeatCount);
    return (
        <div style={styles.toolbar}>
            {/* <div style={styles.newRowGroup}>
                    <span style={styles.newRowLabel}>Új sor székszáma</span>
                    <input
                        type="number"
                        min="1"
                        max={MAX_NEW_ROW_SEAT_COUNT}
                        step="1"
                        value={this.state.newRowSeatCount === undefined || this.state.newRowSeatCount === null ? '' : this.state.newRowSeatCount}
                        onChange={this.handleNewRowSeatCountChange}
                        disabled={readOnly}
                        style={Object.assign({}, styles.newRowInput, !requestedSeatCount ? styles.inputInvalid : {})}
                    />
                    <Button color="success" size="sm" onClick={this.addBlock} disabled={readOnly || !requestedSeatCount}>+ Helyre szóló sor</Button>
                </div> */}
            <div style={styles.zoomGroup}>
                <Button color="secondary" size="sm" type="button" onClick={() => this.zoomCanvas(1 / ZOOM_STEP)}>−</Button>
                <span style={styles.zoomValue}>{Math.round(this.getZoomValue(this.state.zoom) * 100)}%</span>
                <Button color="secondary" size="sm" type="button" onClick={() => this.zoomCanvas(ZOOM_STEP)}>+</Button>
                <Button color="secondary" size="sm" type="button" onClick={this.resetCanvasView}>Minden látszik</Button>
            </div>
            <Button color="success" size="sm" onClick={() => this.setState({ showGridModal: true, gridRows: 5, gridSeats: 10 })} disabled={readOnly}>+ Helyre szóló terület</Button>
            <Button color="success" size="sm" onClick={this.addArea} disabled={readOnly}>+ Nem helyre szóló terület</Button>{' '}
            <Button color="success" size="sm" onClick={this.addObject} disabled={readOnly}>+ Egyéb objektum</Button>{' '}
            <Button color="success" size="sm" onClick={this.addText} disabled={readOnly}>+ Szöveg</Button>{' '}
            <Button color="secondary" size="sm" onClick={this.duplicateSelected} disabled={readOnly || !this.state.selected}>Kijelölt duplikálása</Button>{' '}
            <Button color="danger" size="sm" onClick={this.deleteSelected} disabled={readOnly || !this.state.selected}>Kijelölt törlése</Button>{' '}
            <Button color="secondary" size="sm" type="button" onClick={this.undoLayoutChange} disabled={readOnly || !(this.state.undoStack || []).length}>↶ Visszavonás</Button>{' '}
            <Button color="secondary" size="sm" type="button" onClick={this.redoLayoutChange} disabled={readOnly || !(this.state.redoStack || []).length}>↷ Újra</Button>{' '}
            {/*<Button color="info" size="sm" onClick={this.duplicateLayout} disabled={readOnly}>Teremkiosztás duplikálása</Button>*/}
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center' }}>
                <Button color="secondary" type="button" onClick={this.navToList}>Vissza</Button>{' '}
                <Button color="primary" type="submit" disabled={this.state.mentesButtonLoading}>
                    {this.state.mentesButtonLoading ? 'Mentés...' : 'Mentés'}
                </Button>
            </div>
        </div>
    );
}

renderSeat = (seat, blockIndex, seatIndex) => {
    const selected = this.state.selected || [];
    const isSelected = selected.some(sel => sel.type === 'seat' && sel.blockIndex === blockIndex && sel.seatIndex === seatIndex);
    const fill = this.getSectorColor(seat.sec);
    const isBlockSelected = selected.some(sel => sel.type === 'block' && sel.blockIndex === blockIndex);
    return (
        <g key={seat._cid || seat.sid || seatIndex}
            onMouseDown={e => {
                if (isBlockSelected) {
                    this.startDrag({ type: 'block', blockIndex: blockIndex }, e);
                }
                else {
                    this.startDrag({ type: 'seat', blockIndex: blockIndex, seatIndex: seatIndex }, e);
                }
                if (e.stopPropagation) e.stopPropagation();
            }}
            style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}>
            <circle
                cx={seat.x}
                cy={seat.y}
                r={SEAT_RADIUS}
                fill={fill}
                stroke={isSelected ? '#ffcc00' : '#ffffff'}
                strokeWidth={isSelected ? 4 : 1}
            />
            <text x={seat.x} y={seat.y + 3.5} fontSize="8" textAnchor="middle" fill="#ffffff" pointerEvents="none">{seat.lab}</text>
        </g>
    );
}

renderBlock = (block, blockIndex) => {
    const selected = this.state.selected || [];
    const isSelected = selected.some(sel => sel.type === 'block' && sel.blockIndex === blockIndex);
    const bounds = this.getBlockBounds(block);
    const pivotX = block.pivotX !== undefined ? block.pivotX : (bounds.minX + bounds.maxX) / 2;
    const pivotY = block.pivotY !== undefined ? block.pivotY : (bounds.minY + bounds.maxY) / 2;
    const rot = this.toNumber(block.rot, 0);
    const lap = (this.state.lapOptions || []).find(item => item.name === block.lps) || {};
    const showLeft = lap.left || block.lps === 'B' || block.lps === 'M';
    const showRight = lap.right || block.lps === 'J' || block.lps === 'M';
    const basePadding = 20; 
    const labelSpace = 70;
    const paddingLeft = showLeft ? basePadding + labelSpace : basePadding;
    const paddingRight = showRight ? basePadding + labelSpace : basePadding;
    const rowClickX = bounds.minX - paddingLeft;
    const rowClickY = bounds.minY - 17;
    const rowClickWidth = (bounds.maxX - bounds.minX) + paddingLeft + paddingRight;
    const rowClickHeight = Math.max(34, bounds.maxY - bounds.minY + 34);
    return (
        <g key={block._cid || block.bid || blockIndex} transform={'rotate(' + rot + ' ' + pivotX + ' ' + pivotY + ')'}>
            <rect
                x={rowClickX}
                y={rowClickY}
                width={rowClickWidth}
                height={rowClickHeight}
                fill={isSelected ? 'rgba(255, 204, 0, 0.16)' : 'rgba(0,0,0,0)'}
                stroke={isSelected ? '#ffcc00' : 'transparent'}
                strokeDasharray="4 4"
                onMouseDown={e => this.startDrag({ type: 'block', blockIndex: blockIndex }, e)}
                style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}
            />
            {showLeft ? (
                <text x={bounds.minX - 38} y={bounds.centerY + 4} fontSize="13" textAnchor="end" fill="#e7e5ff" onMouseDown={e => this.startDrag({ type: 'block', blockIndex: blockIndex }, e)} style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}>
                    {block.lab}
                </text>
            ) : null}
            {showRight ? (
                <text x={bounds.maxX + 38} y={bounds.centerY + 4} fontSize="13" textAnchor="start" fill="#e7e5ff" onMouseDown={e => this.startDrag({ type: 'block', blockIndex: blockIndex }, e)} style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}>
                    {block.lab}
                </text>
            ) : null}
            {(block.seats || []).map((seat, seatIndex) => this.renderSeat(seat, blockIndex, seatIndex))}
        </g>
    );
}

renderArea = (area, areaIndex) => {
    const selected = this.state.selected || [];
    const isSelected = selected.some(sel => sel.type === 'area' && sel.areaIndex === areaIndex);
    const x = this.toNumber(area.x, 0);
    const y = this.toNumber(area.y, 0);
    const rot = this.toNumber(area.rot, 0);
    const pivotX = area.pivotX !== undefined ? area.pivotX : x;
    const pivotY = area.pivotY !== undefined ? area.pivotY : y;
    const width = this.toNumber(area.wid, 0);
    const height = this.toNumber(area.hei, 0);
    const cap = this.toNumber(area.cap, 0);
    const fill = cap > 0 ? this.getSectorColor(area.sec) : '#577590';
    return (
        <g
            key={area._cid || area.aid || areaIndex}
            //transform={'rotate(' + this.toNumber(area.rot, 0) + ' ' + x + ' ' + y + ')'}
            transform={`rotate(${rot} ${pivotX} ${pivotY})`}
            onMouseDown={e => this.startDrag({ type: 'area', areaIndex: areaIndex }, e)}
            style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}
        >
            <rect
                x={x - width / 2}
                y={y - height / 2}
                width={width}
                height={height}
                rx={this.toNumber(area.rad, 0)}
                ry={this.toNumber(area.rad, 0)}
                fill={fill}
                fillOpacity={cap > 0 ? 0.85 : 0.95}
                stroke={isSelected ? '#ffcc00' : '#394867'}
                strokeWidth={isSelected ? 4 : 1}
            />
            <text x={x} y={y + this.toNumber(area.las, 12) / 3} fontSize={this.toNumber(area.las, 12)} textAnchor="middle" fill="#ffffff" pointerEvents="none">
                {area.lab}
            </text>

            {isSelected && !this.isReadOnly() ? (() => {
                const rectX = x - width / 2;
                const rectY = y - height / 2;
                const t = 8;
                const resizeBoxColor = "transparent";

                return (
                    <g>
                        {/* Felső négyzet */}
                        <rect
                            x={rectX} y={rectY - t / 2} width={width} height={t} fill={resizeBoxColor}
                            style={{ cursor: 'ns-resize' }}
                            onMouseUp={this.stopDrag}
                            onMouseDown={e => this.startResize('area', areaIndex, 'top', e)}
                        />
                        {/* Alsó négyzet */}
                        <rect
                            x={rectX} y={rectY + height - t / 2} width={width} height={t} fill={resizeBoxColor}
                            style={{ cursor: 'ns-resize' }}
                            onMouseUp={this.stopDrag}
                            onMouseDown={e => this.startResize('area', areaIndex, 'bottom', e)}
                        />
                        {/* Bal négyzet */}
                        <rect
                            x={rectX - t / 2} y={rectY} width={t} height={height} fill={resizeBoxColor}
                            style={{ cursor: 'ew-resize' }}
                            onMouseUp={this.stopDrag}
                            onMouseDown={e => this.startResize('area', areaIndex, 'left', e)}
                        />
                        {/* Jobb négyzet */}
                        <rect
                            x={rectX + width - t / 2} y={rectY} width={t} height={height} fill={resizeBoxColor}
                            style={{ cursor: 'ew-resize' }}
                            onMouseUp={this.stopDrag}
                            onMouseDown={e => this.startResize('area', areaIndex, 'right', e)}
                        />
                    </g>
                );
            })() : null}
        </g>
    );
}

renderTextItem = (text, textIndex) => {
    const selected = this.state.selected;
    const isSelected = selected.some(sel => sel.type === 'text' && sel.textIndex === textIndex);
    const x = this.toNumber(text.x, 0);
    const y = this.toNumber(text.y, 0);
    const rot = this.toNumber(text.rot, 0);
    const pivotX = text.pivotX !== undefined ? text.pivotX : x;
    const pivotY = text.pivotY !== undefined ? text.pivotY : y;
    const fontSize = this.toNumber(text.las, 14);
    const textLength = (text.lab || '').length;
    const estWidth = Math.max(60, textLength * (fontSize * 0.6));
    const estHeight = fontSize + 10;
    const textColor = text.col = '#' + text.col.replace(/^#/, '');
    return (
        <g
            key={text._cid || text.tid || text.id || textIndex}
            //transform={'rotate(' + this.toNumber(text.rot, 0) + ' ' + x + ' ' + y + ')'}
            transform={`rotate(${rot} ${pivotX} ${pivotY})`}
            onMouseDown={e => this.startDrag({ type: 'text', textIndex: textIndex }, e)}
            style={{ cursor: this.isReadOnly() ? 'pointer' : 'move' }}
        >
            {isSelected ? <rect x={x - estWidth / 2} y={y - estHeight / 2} width={estWidth} height={estHeight} fill="rgba(255,204,0,0.15)" stroke="#ffcc00" strokeDasharray="4 4" /> : null}
            <text x={x} y={y} fontSize={this.toNumber(text.las, 14)} textAnchor="middle" dominantBaseline="central" fill={textColor || '#000000'}>{text.lab}</text>

            {isSelected && !this.isReadOnly() ? (
                <rect
                    x={x + estWidth / 2 - 8}
                    y={y - estHeight / 2}
                    width={16}
                    height={estHeight}
                    fill="transparent"
                    style={{ cursor: 'ew-resize' }}
                    onMouseUp={this.stopDrag}
                    onMouseDown={e => this.startResize('text', textIndex, 'right', e)}
                />
            ) : null}
        </g>
    );
}

renderSvg = () => {
    const layout = this.state.layout || this.createEmptyLayout();
    const box = this.getActiveCanvasBox();
    const view = this.getVisibleViewBox(box, this.state.zoom, this.state.viewBoxX, this.state.viewBoxY);
    const Virt_size = 8000;
    const Virt_min = -4000;
    let pctX = ((this.state.viewBoxX || 0) - Virt_min) / Virt_size;
    let pctY = ((this.state.viewBoxY || 0) - Virt_min) / Virt_size;
    pctX = Math.min(Math.max(pctX, 0), 1);
    pctY = Math.min(Math.max(pctY, 0), 1);
    const currentZoom = this.state.zoom || 1;
    const thumbWidth = Math.max(30, 150 / currentZoom); 
    const thumbHeight = Math.max(30, 150 / currentZoom);
    return (
        <div ref={this.setSvgWrapRef} style={Object.assign({}, styles.svgWrap, { position: 'relative', overflow: 'hidden' })}>
            <div style={styles.svgHelpBar}>
                Görgő: zoom • Shift/Alt + húzás az üres háttéren: mozgatás • Ctrl+Z: visszavonás • Ctrl+Y vagy Ctrl+Shift+Z: újra.
            </div>
            {/* --- Felső görgetősáv --- */}
                <div style={{
                    position: 'absolute', top: '30px', left: '10px', right: '25px', height: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: '5px', zIndex: 10
                }}>
                    <div
                        onMouseDown={(e) => this.handleScrollbarMouseDown(e, 'horizontal')}
                        style={{
                            position: 'absolute',
                            left: `calc(${pctX * 100}% - ${pctX * thumbWidth}px)`,
                            width: `${thumbWidth}px`,
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.4)',
                            borderRadius: '5px',
                            cursor: 'grab'
                        }}
                    />
                </div>

                {/* --- Oldalsó görgetősáv --- */}
                <div style={{
                    position: 'absolute', top: '45px', bottom: '10px', right: '10px', width: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: '5px', zIndex: 10
                }}>
                    <div
                        onMouseDown={(e) => this.handleScrollbarMouseDown(e, 'vertical')}
                        style={{
                            position: 'absolute',
                            top: `calc(${pctY * 100}% - ${pctY * thumbHeight}px)`,
                            width: '100%',
                            height: `${thumbHeight}px`,
                            backgroundColor: 'rgba(255, 255, 255, 0.4)',
                            borderRadius: '5px',
                            cursor: 'grab'
                        }}
                    />
                </div>
            <svg
                ref={this.svgRef}
                viewBox={view.x + ' ' + view.y + ' ' + view.width + ' ' + view.height}
                width="100%"
                height="750"
                onMouseMove={this.handleSvgMouseMove}
                onMouseUp={this.stopDrag}
                onMouseLeave={this.stopDrag}
                onMouseDown={this.handleSvgMouseDown}
                style={Object.assign({}, styles.svg, this.state.panDrag ? styles.svgPanning : {})}
            >
                <defs>
                    <pattern id="teremterkepFineGrid" width={GRID_SIZE} height={GRID_SIZE} patternUnits="userSpaceOnUse">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((line) => (
                            <path
                                key={'fine-grid-' + line}
                                d={'M ' + line + ' 0 L ' + line + ' ' + GRID_SIZE + ' M 0 ' + line + ' L ' + GRID_SIZE + ' ' + line}
                                fill="none"
                                stroke="#ffffff"
                                strokeWidth="0.08"
                                opacity="0.09"
                            />
                        ))}
                    </pattern>
                    <pattern id="teremterkepSmallGrid" width={GRID_SIZE} height={GRID_SIZE} patternUnits="userSpaceOnUse">
                        <rect width={GRID_SIZE} height={GRID_SIZE} fill="url(#teremterkepFineGrid)" />
                        <path d={'M ' + GRID_SIZE + ' 0 L 0 0 0 ' + GRID_SIZE} fill="none" stroke="#ffffff" strokeWidth="0.16" opacity="0.18" />
                    </pattern>
                    <pattern id="teremterkepGrid" width={GRID_MAJOR_SIZE} height={GRID_MAJOR_SIZE} patternUnits="userSpaceOnUse">
                        <rect width={GRID_MAJOR_SIZE} height={GRID_MAJOR_SIZE} fill="url(#teremterkepSmallGrid)" />
                        <path d={'M ' + GRID_MAJOR_SIZE + ' 0 L 0 0 0 ' + GRID_MAJOR_SIZE} fill="none" stroke="#ffffff" strokeWidth="0.35" opacity="0.32" />
                    </pattern>
                </defs>
                <rect data-svg-background="true" x="0" y="0" width={box.width} height={box.height} fill="#211536" />
                <rect data-svg-background="true" x="0" y="0" width={box.width} height={box.height} fill="url(#teremterkepGrid)" opacity="0.85" />
                <rect x="0.5" y="0.5" width={box.width - 1} height={box.height - 1} fill="none" stroke="#6a5a83" strokeWidth="1" pointerEvents="none" />
                <g transform={'translate(' + box.offsetX + ' ' + box.offsetY + ')'}>
                    {(layout.areas || []).map((area, areaIndex) => this.renderArea(area, areaIndex))}
                    {(layout.blocks || []).map((block, blockIndex) => this.renderBlock(block, blockIndex))}
                    {(layout.texts || []).map((text, textIndex) => this.renderTextItem(text, textIndex))}
                </g>
            </svg>
        </div>
    );
}

renderSelectedPanel = () => {
    const selected = this.state.selected || [];
    const item = this.getSelectedItem();
    const readOnly = this.isReadOnly();
    if (selected.length === 0 || !item) {
        return (
            <div style={styles.panel}>
                <h5 style={styles.panelTitle}>Teremkép adatai</h5>
                <div style={styles.help}>Kattints egy székre, sorra, területre vagy feliratra. A kijelölt elem itt szerkeszthető, vagy a teremtérképen egérrel mozgatható.</div>
            </div>
        );
    }

    const firstSelectedType = selected[0].type;
    const isMultiSelect = selected.length > 1;

    if (firstSelectedType === 'seat') return this.renderSeatPanel(item, readOnly, isMultiSelect);
    if (firstSelectedType === 'block') return this.renderBlockPanel(item, readOnly, isMultiSelect);
    if (firstSelectedType === 'area') return this.renderAreaPanel(item, readOnly, isMultiSelect);
    if (firstSelectedType === 'text') return this.renderTextPanel(item, readOnly, isMultiSelect);
    return null;
}

updateWorldCoordinate = (field, rawValue) => {
        if (this.isReadOnly()) return;
        const selected = this.state.selected || [];
        if (selected.length === 0 || selected[0].type !== 'seat') return;

        const sel = selected[0];
        const value = this.toNumber(rawValue, 0);

        this.setState((prevState) => {
            const layout = _.cloneDeep(prevState.layout || this.createEmptyLayout());
            const block = layout.blocks[sel.blockIndex];
            const seat = block && block.seats ? block.seats[sel.seatIndex] : null;
            if (!block || !seat) return null;

            const rot = this.toNumber(block.rot, 0);

            if (rot === 0) {
                seat[field] = this.roundCoord(value);
                return { layout, undoStack: this.pushUndoStack(prevState), redoStack: [], successMessage: '', errorMessage: '' };
            }

            if (block.pivotX === undefined || block.pivotX === null) {
                let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                block.seats.forEach(s => {
                    const sx = this.toNumber(s.x, 0);
                    const sy = this.toNumber(s.y, 0);
                    if (sx < minX) minX = sx;
                    if (sx > maxX) maxX = sx;
                    if (sy < minY) minY = sy;
                    if (sy > maxY) maxY = sy;
                });
                if (minX !== Infinity) {
                    block.pivotX = (minX + maxX) / 2;
                    block.pivotY = (minY + maxY) / 2;
                }
            }
            
            const pivotX = block.pivotX;
            const pivotY = block.pivotY;

            const rad = (Math.PI / 180) * rot;
            const cos = Math.cos(rad);
            const sin = Math.sin(rad);
            
            const dx = seat.x - pivotX;
            const dy = seat.y - pivotY;
            
            let worldX = pivotX + (dx * cos) - (dy * sin);
            let worldY = pivotY + (dx * sin) + (dy * cos);

            if (field === 'x') worldX = value;
            if (field === 'y') worldY = value;

            const invRad = (Math.PI / 180) * (-rot);
            const invCos = Math.cos(invRad);
            const invSin = Math.sin(invRad);

            const newDx = worldX - pivotX;
            const newDy = worldY - pivotY;

            const newLocalX = pivotX + (newDx * invCos) - (newDy * invSin);
            const newLocalY = pivotY + (newDx * invSin) + (newDy * invCos);

            seat.x = Math.round(newLocalX * 100000) / 100000;
            seat.y = Math.round(newLocalY * 100000) / 100000;

            return {
                layout: layout,
                undoStack: this.pushUndoStack(prevState),
                redoStack: [],
                successMessage: '',
                errorMessage: ''
            };
        });
    }

renderSectorOptions = () => {
    return (this.state.sectors || []).map(sector => ({
        value: sector.id,
        label: (sector.nam || sector.name || sector.cod || sector.id) + ' (' + sector.id + ')'
    }));
}

// renderSeatPanel = (seat, readOnly, isMultiSelect) => {
//     return (
//         <div style={styles.panel}>
//             <h5 style={styles.panelTitle}>Teremkép adatai: kijelölt szék</h5>
//             {this.renderSelect('Szektor', seat.sec, e => this.updateSelectedField('sec', e.target.value, 'number'), this.renderSectorOptions(), readOnly)}
//             {!isMultiSelect && (
//                 <>
//                     {this.renderInput('X koordináta', Math.round(seat.x), e => this.updateSelectedField('x', e.target.value, 'number'), 'number', readOnly)}
//                     {this.renderInput('Y koordináta', Math.round(seat.y), e => this.updateSelectedField('y', e.target.value, 'number'), 'number', readOnly)}
//                 </>
//             )}
//             {this.renderInput('Szék/Hely felirat', seat.lab, e => this.updateSelectedField('lab', e.target.value), 'text', readOnly)}
//             {/* {this.renderInput('Szék/Hely sorszám', seat.num, e => this.updateSelectedField('num', e.target.value, 'number'), 'number', readOnly)} */}
//             <div style={styles.help}>Szektor: {this.getSectorName(seat.sec)}</div>
//         </div>
//     );
// }
renderSeatPanel = (seat, readOnly, isMultiSelect) => {
        let realX = seat.x;
        let realY = seat.y;
        
        const sel = this.state.selected && this.state.selected[0];
        if (sel && sel.type === 'seat') {
            const block = this.state.layout.blocks[sel.blockIndex];
            if (block) {
                const rot = this.toNumber(block.rot, 0);
                if (rot !== 0) {
                    const bounds = this.getBlockBounds(block);
                    const pivotX = block.pivotX !== undefined ? block.pivotX : (bounds.minX + bounds.maxX) / 2;
                    const pivotY = block.pivotY !== undefined ? block.pivotY : (bounds.minY + bounds.maxY) / 2;
                    
                    const radians = (Math.PI / 180) * rot;
                    const cos = Math.cos(radians);
                    const sin = Math.sin(radians);
                    
                    const dx = seat.x - pivotX;
                    const dy = seat.y - pivotY;
                    
                    realX = pivotX + (dx * cos) - (dy * sin);
                    realY = pivotY + (dx * sin) + (dy * cos);
                }
            }
        }

        return (
            <div style={styles.panel}>
                <h5 style={styles.panelTitle}>Teremkép adatai: kijelölt szék</h5>
                {this.renderSelect('Szektor', seat.sec, e => this.updateSelectedField('sec', e.target.value, 'number'), this.renderSectorOptions(), readOnly)}
                {!isMultiSelect && (
                    <>
                        {this.renderInput('X koordináta', Math.round(realX), e => this.updateWorldCoordinate('x', e.target.value), 'number', readOnly)}
                        {this.renderInput('Y koordináta', Math.round(realY), e => this.updateWorldCoordinate('y', e.target.value), 'number', readOnly)}
                    </>
                )}
                {this.renderInput('Szék/Hely felirat', seat.lab, e => this.updateSelectedField('lab', e.target.value), 'text', readOnly)}
                <div style={styles.help}>Szektor: {this.getSectorName(seat.sec)}</div>
            </div>
        );
    }

renderBlockPanel = (block, readOnly, isMultiSelect) => {
    const anchor = this.getBlockAnchor(block);
    const lapOptions = (this.state.lapOptions || []).map(item => ({ value: item.name, label: item.caption || item.name }));
    const isPartOfGrid = !!block.gridId;
    const sectorRowCount = isPartOfGrid ? (this.state.layout.blocks || []).filter(b => b.gridId === block.gridId).length : 0;
    const currentSeatCount = block.seats ? block.seats.length : 0;
    return (
        <div style={styles.panel}>
            {/* <h5 style={styles.panelTitle}>Teremkép adatai: kijelölt sor</h5> */}
            <h5 style={styles.panelTitle}>{isPartOfGrid ? 'Teremkép adatai: helyre szóló terület (Sor)' : 'Teremkép adatai: kijelölt sor'}</h5>
            {this.renderSelect('Szektor*', block.sec, e => this.updateSelectedField('sec', e.target.value, 'number'), this.renderSectorOptions(), readOnly)}
            {isPartOfGrid ? (this.renderInput('Sorok száma*', sectorRowCount, 'number', readOnly, true)) : null}
            {this.renderInput('Sorban székek száma*', currentSeatCount, 'number', readOnly, true)}
            {this.renderInput('Sor felirat', block.lab, e => this.updateSelectedField('lab', e.target.value), 'text', readOnly)}
            {this.renderSelect('Sor felirat pozíció', block.lps, e => this.updateSelectedField('lps', e.target.value), lapOptions, readOnly)}
            {this.renderSelect('Sorszámozás iránya', block.rev ? 'true' : 'false', e => this.updateSelectedField('rev', e.target.value === 'true', 'boolean'), [{ value: 'false', label: 'Balról jobbra' }, { value: 'true', label: 'Jobbról balra' }], readOnly)}
            {this.renderInput('Szék/Hely prefix', block.lsp, e => this.updateSelectedField('lsp', e.target.value), 'text', readOnly)}
            {this.renderInput('Szék/Hely suffix', block.lss, e => this.updateSelectedField('lss', e.target.value), 'text', readOnly)}
            {this.renderInput('Székköz (X tengely)*', block.seatGap || 30, e => this.updateSelectedField('seatGap', e.target.value, 'number'), 'number', readOnly)}
            {isMultiSelect && (
                <>
                    {this.renderInput('Sorköz (Y tengely)*', block.rowGap || 30, e => this.updateSelectedField('rowGap', e.target.value, 'number'), 'number', readOnly)}
                </>
            )}
            {this.renderInput('Forgatás*', block.rot || 0, e => this.updateSelectedField('rot', e.target.value, 'number'), 'number', readOnly)}
            {!isMultiSelect && (
                <>
                    {this.renderInput('X koordináta*', anchor.x, e => this.updateSelectedField('x', e.target.value, 'number'), 'number', readOnly)}
                    {this.renderInput('Y koordináta*', anchor.y, e => this.updateSelectedField('y', e.target.value, 'number'), 'number', readOnly)}
                </>
            )}
            <div style={styles.help}>A sor kijelöléséhez kattints a sor feliratára vagy a székek melletti üres sávra. A sor mozgatása az összes benne lévő széket együtt mozgatja.</div>
        </div>
    );
}

renderAreaPanel = (area, readOnly, isMultiSelect) => {
    const isCapacityArea = this.toNumber(area.cap, 0) > 0;
    return (
        <div style={styles.panel}>
            <h5 style={styles.panelTitle}>Teremkép adatai: {isCapacityArea ? 'nem helyre szóló terület' : 'egyéb objektum'}</h5>
            {isCapacityArea ? this.renderSelect('Szektor*', area.sec, e => this.updateSelectedField('sec', e.target.value, 'number'), this.renderSectorOptions(), readOnly) : null}
            {isCapacityArea ? this.renderInput('Férőhely*', area.cap, e => this.updateSelectedField('cap', e.target.value, 'number'), 'number', readOnly) : null}
            {!isMultiSelect && (
                <>
                    {this.renderInput('X koordináta*', area.x, e => this.updateSelectedField('x', e.target.value, 'number'), 'number', readOnly)}
                    {this.renderInput('Y koordináta*', area.y, e => this.updateSelectedField('y', e.target.value, 'number'), 'number', readOnly)}
                </>
            )}
            {this.renderInput('Szélesség*', area.wid, e => this.updateSelectedField('wid', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Magasság*', area.hei, e => this.updateSelectedField('hei', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Lekerekítés*', area.rad, e => this.updateSelectedField('rad', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Forgatás*', area.rot, e => this.updateSelectedField('rot', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Felirat', area.lab, e => this.updateSelectedField('lab', e.target.value), 'text', readOnly)}
            {this.renderInput('Felirat mérete', area.las, e => this.updateSelectedField('las', e.target.value, 'number'), 'number', readOnly)}
        </div>
    );
}

renderTextPanel = (text, readOnly, isMultiSelect) => {
    return (
        <div style={styles.panel}>
            <h5 style={styles.panelTitle}>Teremkép adatai: szöveg</h5>
            {!isMultiSelect && (
                <>
                    {this.renderInput('X koordináta*', text.x, e => this.updateSelectedField('x', e.target.value, 'number'), 'number', readOnly)}
                    {this.renderInput('Y koordináta*', text.y, e => this.updateSelectedField('y', e.target.value, 'number'), 'number', readOnly)}
                </>
            )}
            {this.renderInput('Forgatás*', text.rot, e => this.updateSelectedField('rot', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Felirat*', text.lab, e => this.updateSelectedField('lab', e.target.value), 'text', readOnly)}
            {this.renderInput('Felirat mérete*', text.las, e => this.updateSelectedField('las', e.target.value, 'number'), 'number', readOnly)}
            {this.renderInput('Felirat színe*', text.col, e => this.updateSelectedField('col', e.target.value), 'color', readOnly)}
        </div>
    );
}

renderSummary = () => {
    const layout = this.state.layout || this.createEmptyLayout();
    const seatCount = (layout.blocks || []).reduce((sum, block) => sum + ((block.seats || []).length), 0);
    const areaCount = (layout.areas || []).filter(area => this.toNumber(area.cap, 0) > 0).length;
    const objectCount = (layout.areas || []).filter(area => this.toNumber(area.cap, 0) === 0).length;
    return (
        <div style={styles.summary}>
            <span>Blokkok/sorok: <strong>{(layout.blocks || []).length}</strong></span>
            <span>Székek: <strong>{seatCount}</strong></span>
            <span>Nem helyre szóló területek: <strong>{areaCount}</strong></span>
            <span>Egyéb objektumok: <strong>{objectCount}</strong></span>
            <span>Szövegek: <strong>{(layout.texts || []).length}</strong></span>
        </div>
    );
}

render() {
    let cardStyle = {
        padding: 20
    };
    return (
        <div>
            {/*Ez a style azért kell, hogy működjön a sticky toolbar*/}
            <style>{` 
                    .app-body, .main, .container-fluid, .c-body, .c-main {
                        overflow: visible !important;
                        overflow-x: visible !important;
                        overflow-y: visible !important;
                    }
                `}</style>
            <div className="animated fadeIn">
                <div className="card">
                    <div className="card-header">
                        {this.state.cim}
                    </div>
                    {this.state.loading
                        ? <Loader />
                        : (
                            <form onSubmit={this.mentes}>
                                <div style={cardStyle}>
                                    {/* {this.state.errorMessage ? <div className="alert alert-danger">{this.state.errorMessage}</div> : null}
                                    {this.state.successMessage ? <div className="alert alert-success">{this.state.successMessage}</div> : null} */}
                                    <div style={styles.layout}>
                                        <div style={styles.leftColumn}>
                                            {this.renderBaseData()}
                                            {this.renderSelectedPanel()}
                                        </div>
                                        <div style={styles.rightColumn}>
                                            {this.renderToolbar()}
                                            {this.renderSummary()}
                                            {this.renderSvg()}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )
                    }
                </div>
            </div>
            <Modal isOpen={this.state.showGridModal} toggle={this.toggleGridModal} backdrop="static">
                <ModalHeader toggle={this.toggleGridModal}>Helyre szóló terület hozzáadása</ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label>Sorok száma:</label>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            max="100"
                            value={this.state.gridRows}
                            onChange={e => this.setState({ gridRows: e.target.value })}
                        />
                    </div>
                    <div className="form-group">
                        <label>Székek száma soronként:</label>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            max="100"
                            value={this.state.gridSeats}
                            onChange={e => this.setState({ gridSeats: e.target.value })}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.addGrid}>OK</Button>
                    <Button color="secondary" onClick={this.toggleGridModal}>Mégsem</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}
}

const styles = {
    layout: {
        display: 'flex',
        gap: 20,
        alignItems: 'flex-start'
    },
    leftColumn: {
        width: 320,
        minWidth: 320
    },
    rightColumn: {
        flex: 1,
        minWidth: 0
    },
    panel: {
        border: '1px solid #d8dbe0',
        borderRadius: 4,
        padding: 12,
        marginBottom: 12,
        background: '#ffffff'
    },
    panelTitle: {
        margin: '0 0 12px 0',
        fontSize: 16,
        fontWeight: 600
    },
    field: {
        marginBottom: 10
    },
    label: {
        display: 'block',
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 3
    },
    input: {
        width: '100%',
        height: 32,
        border: '1px solid #c8ced3',
        borderRadius: 4,
        padding: '4px 8px'
    },
    toolbar: {
        marginBottom: 10,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 6,
        position: 'sticky',
        top: '60px',
        zIndex: 1050,
        backgroundColor: '#ffffff',
        padding: '10px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    },
    newRowGroup: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 6px',
        border: '1px solid #d8dbe0',
        borderRadius: 4,
        background: '#ffffff'
    },
    newRowLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: '#4f5d75',
        whiteSpace: 'nowrap'
    },
    newRowInput: {
        width: 74,
        height: 28,
        border: '1px solid #c8ced3',
        borderRadius: 4,
        padding: '3px 6px'
    },
    zoomGroup: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 6px',
        border: '1px solid #d8dbe0',
        borderRadius: 4,
        background: '#ffffff'
    },
    zoomValue: {
        minWidth: 44,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 700,
        color: '#4f5d75'
    },
    inputInvalid: {
        borderColor: '#dc3545',
        background: '#fff5f5'
    },
    summary: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px 18px',
        fontSize: 12,
        marginBottom: 10,
        color: '#4f5d75'
    },
    svgWrap: {
        border: '1px solid #c8ced3',
        borderRadius: 4,
        overflow: 'auto',
        background: '#eef1f5',
        padding: 8,
        boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.08)',
        overscrollBehavior: 'contain',
        touchAction: 'none'
    },
    svgHelpBar: {
        fontSize: 12,
        color: '#4f5d75',
        marginBottom: 6,
        lineHeight: '16px'
    },
    svg: {
        display: 'block',
        minWidth: 760,
        userSelect: 'none',
        background: '#211536',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.18)',
        cursor: 'default'
    },
    svgPanning: {
        cursor: 'grabbing'
    },
    footerActions: {
        marginTop: 16,
        textAlign: 'right'
    },
    help: {
        fontSize: 12,
        color: '#6c757d',
        lineHeight: '16px'
    },
    warning: {
        fontSize: 12,
        color: '#856404',
        background: '#fff3cd',
        border: '1px solid #ffeeba',
        borderRadius: 4,
        padding: 8,
        marginTop: 8
    }
};

export default TeremterkepEditorBase;
